module.exports = {
  alarmSavedAdMessage:
    'Ваш будильник удалось сохранить. Теперь вы увидите короткую рекламу, которую можно закрыть через несколько секунд. Это поможет нам сохранить приложение бесплатным.\n\nМы стараемся показывать только одну рекламу в день. Чтобы убрать рекламу и разблокировать дополнительные функции, обновите наш премиум-план.',
  genericAdMessage:
    'Теперь вы увидите короткую рекламу, которую можно закрыть через несколько секунд. Это поможет нам сохранить приложение бесплатным.\n\nМы стараемся показывать только одну рекламу в день. Чтобы убрать рекламу и разблокировать дополнительные функции, обновите наш премиум-план.',
  alarmDeletedAdMessage:
    'Ваш будильник был удален. Теперь вы увидите короткую рекламу, которую можно закрыть через несколько секунд. Это поможет нам сохранить приложение бесплатным.\n\nМы стараемся показывать только одну рекламу в день. Чтобы убрать рекламу и разблокировать дополнительные функции, обновите наш премиум-план.',
  alarmWithSnoozeAt: 'Следующий звонок будильника раздастся при {{timeString}}',
  removeImage: 'Удалить изображение',
  timezoneMismatchDetected:
    'Что-то подсказывает нам, что вы находитесь в другом часовом поясе, чем в прошлый раз, когда вы использовали Galarm.\n\nСтарый часовой пояс: {{oldTimezone}}\nНовый часовой пояс: {{newTimezone}}\n\nЭто может быть связано с изменением вашего местоположения или с изменением часового пояса на вашем устройстве.\n\nПожалуйста, перезапустите Galarm, чтобы мы могли адаптироваться к новому часовому поясу.',
  nTimes: { one: '1 раз', other: '{{count}} раз' },
  loggedIntoOrganizationAccount: 'Орг: {{organizationName}}\nРоль: {{role}}',
  adsMessage:
    '\nСпасибо, что доверяете компании Galarm. Чтобы поддержать его развитие, вы можете время от времени видеть рекламу.\n\nОбновите наш бюджетный премиум-план, чтобы работать без рекламы и получить доступ к еще большему количеству отличных функций.',
  headsUp: 'Внимание!',
  dataRetention: 'Сохранение данных',
  retainIncidentsForDuration: 'Длительность сохранения инцидента',
  retainIncidentsForDurationDescription:
    'Указывает длительность сохранения инцидента в системе после его закрытия. Даже при настройке "Не сохранять" инциденты могут оставаться в системе до четырех часов, прежде чем будут удалены во время периодического цикла очистки.',
  noRetention: 'Нет удержания',
  fetchingData: 'Получение данных...',
  errorFetchingData: 'Ошибка при получении данных: {{message}}',
  incidentsCleanupLevel: 'Инциденты Уровень очистки',
  incidentsCleanupLevelDescription:
    'Указывает состояние инцидента, до которого инциденты очищаются во время периодического цикла очистки. Если установлено значение "Закрыт", то очищаются все закрытые инциденты. Если задано состояние "Подтвержден", очищаются все инциденты, которые были подтверждены или закрыты.',
  incidentNameTemplate: 'Шаблон названия инцидента',
  invalidIncidentNameTemplate:
    'Неверный шаблон имени инцидента. Обратите внимание, что в качестве имен переменных можно добавить только "идентификатор" и "имя". Проверьте шаблон и повторите попытку. При возникновении проблем обратитесь в службу поддержки.',
  preferredSourceForIncidentsDescription:
    'Если вы хотите использовать прослушиватель в качестве веб-хука или получать инциденты от инструмента мониторинга, выберите источник из списка ниже. Когда вы выберете источник, мы покажем инструкции по интеграции слушателя с этим источником.\n\nЭто необязательно, и вы можете просмотреть инструкции для любого источника позже, используя опцию меню "Просмотр кода" для слушателя.',
  attachScreenshotsToFeedback:
    'Вы получите электронное письмо с подтверждением того, что мы получили ваш отзыв. Если вы хотите поделиться скриншотами, чтобы помочь нам лучше понять проблему, пожалуйста, ответьте на письмо со скриншотами.',
  checkFeedbackReceipt:
    'Пожалуйста, проверьте свой почтовый ящик на наличие письма, подтверждающего вашу заявку. Если вы не видите его в папке "Входящие", проверьте папку "Спам" и добавьте support@galarm.zendesk.com в свою адресную книгу.\n\nЕсли вы хотите поделиться скриншотами, чтобы помочь нам лучше понять проблему, пожалуйста, ответьте на письмо со скриншотами.',
  dontShowMessageAgain: 'Не показывайте это сообщение снова',
  chooseDuration:
    'Выберите продолжительность. Нажмите несколько раз, чтобы увеличить продолжительность.',
  chargedAtPurchase:
    'Счет будет выставлен в момент покупки. Цена включает в себя 20-процентную ознакомительную скидку.',
  lookingForLifetimePlan: 'Нажмите здесь, чтобы получить пожизненный план >',
  viewPremiumFeaturesDescription:
    'Спасибо, что являетесь пользователем премиум-класса. Ваш премиум-план предлагает эти функции.',
  accessToPremiumFeatures:
    'Премиум-планы предлагают вам следующие возможности:',
  purchasedLifetimePlan: 'Вы приобрели план Lifetime Premium.',
  lifetimePremium: 'Пожизненная премия',
  buyNow: 'Купить сейчас',
  cancelProduct: 'Отменить товар',
  endTimeForCreatorCrossesMidnightForRecipientAlarm:
    'Время окончания будильника создателя пересекает полночь. Пожалуйста, установите правильное время окончания.',
  specificDates: 'Конкретные даты',
  specificDatesRepetition: {
    one: 'Определенные даты (1 появление)',
    other: 'Конкретные даты ({{count}} )'
  },
  specificDatesRepetitionSummary:
    'Конкретные даты ({{remaining}}/{{total}} оставшиеся)',
  nOccurrences: { one: '1 Происшествие', other: '{{count}} Происшествия' },
  addOrRemoveAlarmOccurrences:
    'Вы можете добавлять события в любом порядке. Вы можете нажать на любую дату или время, чтобы изменить их.',
  chooseTime: 'Выберите время...',
  specificDatesRepetitionPremiumScreenDescription:
    'С помощью этого повтора можно настроить будильник на определенные даты.',
  chooseAtLeastOneOccurrence: 'Пожалуйста, выберите хотя бы один случай.',
  editRotation: 'Редактировать вращение',
  alertIncidentClosed: 'Закрыто на {{memberName}} в {{dateString}}',
  alertIncidentRecovered: 'Автовосстановление при {{dateString}}',
  alertedAssignees: 'Оповещен {{assigneesString}}',
  acknowledgedBy: 'Подтверждено {{memberName}}',
  closedBy: 'Закрыто {{memberName}}',
  docs: 'Документация',
  docsSmall: 'Docs',
  openingBillingPortal: 'Открытие биллингового портала',
  releaseNotes: 'Последние обновления',
  loadingReleaseNotes:
    'Загрузка последних обновлений. Убедитесь, что вы подключены к Интернету.',
  unableToChangePlan:
    'Невозможно перейти на новый тарифный план. Обратитесь в службу технической поддержки, используя "Настройки > Обратная связь".',
  customSnooze: 'Другие',
  customSnoozeDuration: 'Другое ({{durationString}})',
  snoozeDuration: 'Длительность спящего режима',
  action: 'Действие',
  unableToAuthenticateUser:
    'Невозможно аутентифицировать пользователя. {{error}}',
  addOccurrence: 'Добавить происшествие',
  closeIncidents: 'Близкие инциденты',
  closingIncidents: 'Закрытие инцидентов',
  olderThanHours: 'Старше (часов)',
  errorLoadingRecaptcha:
    'Произошла ошибка при загрузке задания reCAPTCHA. Пожалуйста, повторите попытку через некоторое время и свяжитесь с технической поддержкой, если проблема не исчезнет.',
  completeRecaptcha:
    'Чтобы продолжить регистрацию, выполните следующее задание.',
  incidentNotesPlaceholder:
    'Добавьте примечания к этому инциденту (необязательно)',
  rotationMustHaveMembers: 'В ротации должен быть хотя бы один участник.',
  listenerMustHaveTriggers: 'Слушатель должен иметь хотя бы один триггер.',
  rotationExpiresOn: 'Срок действия истекает {{dateString}}',
  editAndSaveRotationToSetExpirationDate:
    'Отредактируйте и сохраните ротацию, чтобы установить срок действия.',
  cantEnableAlarmNoValidNextDate:
    'Невозможно включить сигнал тревоги. Нет действительной следующей даты для сигнала тревоги.',
  noValidNextDateForAlarm:
    'Нет действительной следующей даты для сигнала тревоги.',
  chords: 'Аккорды',
  discovery: 'Discovery',
  rainforest: 'Дождевой лес',
  wishes: 'Пожелания',
  cantUpdateTimezoneForAllAlarms:
    'Невозможно обновить часовой пояс для существующих сигналов тревоги',
  cantUpdateRingtonesForAllAlarms:
    'Невозможно обновить настройки звука и вибрации для существующих сигналов тревоги',
  preReminderWillRingAt: {
    zero: 'Предварительное напоминание об этом сигнале прозвучит \nна сайте {{timeString}}.',
    one: 'Предварительное напоминание об этом сигнале прозвучит \nпо адресу {{timeString}} в предыдущий день.',
    other:
      'Предварительное напоминание об этом сигнале прозвучит \nна сайте {{timeString}} {{count}} за несколько дней до этого.'
  },
  verficationCodeInfo:
    'Вы получите текстовое сообщение или телефонный звонок с 4-значным кодом.',
  verficationCodeInfoWhatsApp:
    'Вы получите сообщение WhatsApp с 4-значным кодом.',
  deletePastAlarmsNotificationMessage:
    'У вас есть несколько неактивных будильников. Пожалуйста, удалите сигналы, которые вам больше не нужны.',
  confirmCountryCodeAndEnterNumber:
    'Пожалуйста, подтвердите код страны и введите номер телефона.',
  sendCodeOnSms: 'Отправьте код через SMS',
  sendCodeOnWhatsApp: 'Отправьте код через WhatsApp',
  verifyNumberWhatsApp:
    'Мы отправим сообщение WhatsApp с проверочным кодом по адресу:\n\n{{formattedMobileNumber}}',
  verifyNumberCall:
    'Вам позвонят и сообщат проверочный код:\n    \n{{formattedMobileNumber}}',
  defaultTimezoneForAlarm: 'Часовой пояс по умолчанию для сигналов тревоги',
  changeDefaultTimezoneForAllExistingAlarms: {
    zero: 'Хотите ли вы сбросить часовой пояс для всех существующих будильников?',
    one: 'Хотите ли вы изменить часовой пояс для всех существующих сигналов тревоги на этот часовой пояс? Сигналы тревоги будут звонить в настроенное время в новом часовом поясе.'
  },
  changeDefaultRingerSettingsForAllExistingAlarms:
    'Хотите изменить настройки звука и вибрации для существующих будильников?\n  \n  Если вы выберете Да, существующие сигналы тревоги будут звучать с новыми настройками. Если вы выберете "Нет", существующие сигналы будут продолжать звучать со старыми настройками.',
  defaultTimezoneChangedForAllAlarms:
    'Часовой пояс изменен для всех будильников.',
  ringerSettingsChangedForAllAlarms:
    'Изменены настройки звука и вибрации для существующих сигналов тревоги.',
  unlimitedAlarmsFeatureDescription:
    'Создавайте больше групповых и дружеских оповещений.',
  instantAlarmsPremiumFeature: 'Отправляйте мгновенные оповещения',
  instantAlarmsFeatureDescription:
    'Отправляйте множество мгновенных оповещений своим контактам и группам.',
  duplicateAlarmPremiumFeature: 'Дублирующая сигнализация',
  duplicateAlarmFeatureDescription:
    'Быстрое создание копий сигнала тревоги с одинаковыми настройками и внесение изменений перед сохранением.',
  showingAlarmsForDate: 'Показывает сигналы тревоги для {{date}}',
  shareAlarm: 'Поделиться ссылкой на тревожный сигнал',
  shareAlarmDescription:
    'Вы можете поделиться этим сигналом с любым человеком, используя ссылку, не добавляя его в качестве контакта. Если кто-то нажмет на ссылку на своем телефоне, будет создана копия сигнала тревоги.',
  sendCodeAgain: 'Отправьте код еще раз',
  selectDefaultTimezoneForAlarmDefaultTooltipMessage:
    'Выберите часовой пояс по умолчанию для будильников. Вы можете изменить часовой пояс для будильников при их создании.',
  alarmLinkRelativeToTimezone: '{{timeString}} в своем часовом поясе.',
  alarmLinkNotRelativeToTimezone:
    'Будильник для всех прозвенит в {{timeString}}',
  alarmShouldRingAt: 'Будильник для всех прозвенит в:',
  showHourlyAlarms: 'Показать часовые сигналы тревоги',
  critical: 'Критический',
  alarmsWillBeAutomaticallyDeleted:
    'Сигналы тревоги будут удалены навсегда через 30 дней после удаления.',
  unlimitedAlarmsPremiumFeature:
    'Неограниченное количество групповых и дружеских сигналов тревоги',
  notAcknowledged: 'Не подтверждено',
  closed: 'Закрытый',
  showFullScreenIntents: 'Показать будильник на весь экран',
  showFullScreenIntentsDescription:
    'Будильник будет отображаться на весь экран, когда телефон заблокирован.',
  percentVolume: '{{volume}}% объема',
  selectADate: 'Пожалуйста, выберите дату, чтобы просмотреть сигналы тревоги.',
  affiliates: 'Аффилированные лица',
  referralCount: 'Количество обращений',
  addAffiliate: 'Добавить партнера',
  creatingAffiliate: 'Создание партнерской программы',
  affiliateLink: 'Партнерская ссылка',
  upgradeRequiredForWeb: 'Требуется обновление',
  upgradeToPremiumForWeb:
    'Для использования этой функции требуется премиум-подписка. Чтобы воспользоваться этой функцией, приобретите премиум-подписку в мобильном приложении.',
  accountType: 'Тип счета',
  profileAndSettings: 'Профиль и настройки',
  confirmIncidents: 'Подтвердите несколько инцидентов',
  removeIncidents: 'Удаление нескольких инцидентов',
  incidents: 'Инциденты',
  closeSelectedIncidents: 'Закрыть выбранные инциденты',
  viewIncidentNotes: 'Просмотреть заметки о происшествиях',
  incidentNotes: 'Заметки о происшествиях',
  addNote: 'Добавить заметку',
  noAdditionalNotesForIncident:
    'Никаких дополнительных примечаний к этому инциденту.',
  fromIncident: 'Из происшествия:',
  fromUsers: 'От пользователей:',
  database: 'База данных',
  chooseFirstDayOfWeek: 'Выберите первый день недели',
  firstDayOfWeek: 'Первый день недели',
  changePlan: 'План изменений',
  currentPremiumSubscriptionStatus:
    'В настоящее время вы подписаны на тарифный план {{planName}}.',
  currentProSubscriptionStatus: 'Вы являетесь членом организации {{orgName}}.',
  changeToAnnualPlan: 'Изменения в годовом плане',
  confirmChangeToAnnualPlan: 'Хотите перейти на годовой план?',
  changeToAnnualPlanDescription:
    'За годовой план будет взиматься плата {{price}}. Все оставшиеся дни в вашем текущем плане будут скорректированы в соответствии с годовым планом.',
  alarmTimezoneChanged:
    'Некоторые сигналы тревоги были обновлены для использования часового пояса устройства, поскольку часовой пояс, используемый для этих сигналов тревоги, не поддерживается данным устройством.',
  defaultTimezoneChanged:
    'Часовой пояс по умолчанию для сигналов тревоги изменен на часовой пояс устройства, поскольку часовой пояс {{defaultTimezoneForAlarm}} не поддерживается этим устройством.',
  invalidEmail: 'Неверный адрес электронной почты.',
  unableToValidateEmail: 'Невозможно подтвердить электронную почту. {{error}}',
  havingProblems: 'У вас проблемы?',
  alertData: 'Данные оповещения',
  notificationActionBehavior: 'Поведение действия уведомления',
  foreground: 'Передний план',
  background: 'Фон',
  notificationActionBehaviorTooltipMessage:
    'Если установить значение "Передний план", при нажатии на действие с уведомлением приложение будет открыто на переднем плане. Если установить значение "Фон", при нажатии на действие уведомления приложение будет оставаться в фоновом режиме.',
  getCodeOnWhatsApp: 'Получить код в WhatsApp',
  getCode: 'Получить код',
  dontHaveWhatsApp: 'У вас нет WhatsApp?',
  unableToSendCodeViaWhatsAppTitle: 'Невозможно отправить код через WhatsApp',
  unableToSendCodeViaWhatsAppMessage:
    '{{error}}\n      \nПожалуйста, запросите код еще раз по другому каналу.',
  dataSecurity: 'Безопасность данных',
  alarms: 'Сигналы тревоги',
  contacts: 'Контакты',
  groups: 'Группы',
  settings: 'Настройки',
  notificationsTab: 'Уведомления',
  specifyTimeInFutureForAlarm: 'Тревога не может остаться в прошлом.',
  specifyTimeInFutureForPreReminder:
    'Предварительное напоминание о будильнике осталось в прошлом.',
  specifyNameForGroup: 'Имя группы обязательно.',
  updatingGroupName: 'Обновление информации о группе.',
  unableToEditGroupName:
    'Невозможно обновить информацию о группе. Пожалуйста, повторите попытку через некоторое время.',
  selectSmallerImage:
    'Размер изображения превышает 10 МБ. Выберите изображение меньшего размера.',
  sendingVerificationCode:
    'Отправка кода проверки на {{formattedMobileNumber}}.',
  verifyingCode: 'Проверка кода.',
  creatingUserProfile: 'Настройка...',
  unabeToCreateUserProfile:
    'В данный момент не удается создать учетную запись. Пожалуйста, повторите попытку через несколько минут.',
  unableToSendVerificationCode:
    'Невозможно отправить проверочный код. {{error}}',
  unableToVerifyCode: 'Невозможно проверить код. {{error}}',
  unableToRegisterUserWithoutMobileNumber:
    'Невозможно выполнить настройку. {{error}}',
  permissionDeniedToAccessCameraIos:
    'У Galarm нет разрешения на доступ к камере. \n\nПерейдите в Настройки > Galarm и разрешите доступ к камере.',
  permissionDeniedToAccessCameraAndroid:
    'У Galarm нет разрешения на доступ к камере.\n\nПерейдите в Настройки > Приложения > Galarm > Разрешения и разрешите доступ к камере.',
  permissionDeniedToAccessPhotosIos:
    'У Galarm нет разрешения на доступ к фотографиям.\n\nПерейдите в Настройки > Galarm и разрешите доступ к фотографиям.',
  permissionDeniedToAccessPhotosAndroid:
    'У Galarm нет разрешения на доступ к фотографиям.\n\nПерейдите в "Настройки" > "Приложения" > "Galarm" > "Разрешения" и разрешите доступ к хранилищу.',
  permissionDeniedToAccessCalendarIos:
    'У Galarm нет разрешения на доступ к календарю.\nПерейдите в Настройки > Календари и разрешите доступ Galarm.',
  permissionDeniedToAccessCalendarAndroid:
    'У Galarm нет разрешения на доступ к календарю.\nПерейдите в Настройки > Приложения > Galarm > Разрешения и разрешите доступ к календарю.',
  verificationCodeSent:
    'Код проверки отправлен на адрес {{formattedMobileNumber}}.',
  rateTheApp:
    'Мы надеемся, что Galarm будет вам полезен. Пожалуйста, уделите время и оцените нас в Play Store. Спасибо за поддержку.',
  backgroundAppRefreshDisabledPermission:
    'Будильники могут не звонить, потому что у Galarm нет разрешения на фоновое обновление приложений.\n\nНажмите "Включить" и включите "Фоновое обновление приложений".',
  selectedGroupUnselected:
    'В качестве участников можно выбрать группу или набор контактов. Выбранная ранее группа будет снята. Приступить?',
  selectedContactsUnselected:
    'В качестве участников можно выбрать группу или набор контактов. Ранее выбранные контакты будут сняты с выбора. Приступить?',
  notificationsDisabledIos:
    'Будильники не будут звонить, потому что у Galarm нет разрешения на показ уведомлений.\n\nПерейдите в Настройки > Galarm > Уведомления и включите "Оповещения", "Звуки" и "Баннеры".',
  notificationsDisabledAndroid:
    'Уведомления о тревоге не будут отображаться на экране.\n\nНажмите "Включить", выберите "Уведомления" и разрешите уведомления.',
  alarmNotificationChannelDisabled:
    'Уведомления о будильниках не будут появляться на экране. \n\nНажмите "Включить", чтобы уведомления о будильниках появлялись на экране.',
  alarmLockScreenNotificationlDisabled:
    'Уведомления о будильниках не будут отображаться на экране блокировки. \n\nНажмите "Включить", чтобы уведомления о будильниках отображались на экране блокировки.',
  alarmWillNotRingDueToNotificationsDisabledIos:
    'Сигналы тревоги не будут звонить, так как уведомления отключены.\n\nПерейдите в Настройки > Galarm > Уведомления и включите "Оповещения", "Звуки" и "Баннеры".',
  alarmWillNotRingDueToCriticalAlertsDisabledIos:
    'Сигналы тревоги не будут звонить, если телефон отключен, поскольку критические оповещения отключены.\n\nПерейдите в Настройки > Galarm > Уведомления и включите "Критические оповещения".',
  alarmWillNotRingDueToNotificationsDisabledAndroid:
    'Сигнал тревоги не появится на экране, поскольку уведомления отключены.\n\nНажмите "Включить", выберите "Уведомления" и разрешите уведомления.',
  noNotificationsScheduledAlarmInPast:
    'Сигнал тревоги находится в прошлом. Никаких уведомлений не запланировано.',
  alarmOverAllowedLimit: {
    zero: '\nВы достигли предела тревог {{limit}}.\n\nПожалуйста, удалите или повторно используйте существующий сигнал.',
    one: 'Вы достигли предела тревог {{limit}}.\n\nУ вас есть 1 неактивный сигнал, который вы можете удалить или использовать повторно.',
    other:
      'Вы достигли предела тревог {{limit}}.\n\nУ вас есть {{count}} неактивных сигналов тревоги, которые вы можете удалить или использовать повторно.'
  },
  alarmAlreadyConfirmed: 'Вы уже подтвердили.',
  alarmAlreadyDeclined: 'Вы уже отказались.',
  participantMovedToPosition: '{{name}} переместился на позицию {{count}}.',
  memberIsFirstParticpant: '{{name}} первый участник.',
  memberIsLastParticpant: '{{name}} последний участник.',
  cantContinueWithRegistrationWhenOffline:
    'Невозможно продолжить регистрацию, так как устройство находится в автономном режиме.',
  cantContinueWithRegistrationWhenOfflineWithTryAgain:
    'Невозможно продолжить регистрацию, так как устройство находится в автономном режиме. Убедитесь, что вы подключены к Интернету.',
  confirmBlockContact:
    'Вы больше не будете получать сигналы тревоги с сайта {{name}}. Продолжить?',
  confirmUnblockContact:
    'Разблокировав {{name}}, вы также восстановите заблокированные сигналы тревоги. Продолжить?',
  unblockingContact: 'Разблокировка {{name}} и восстановление сигнализации.',
  unableToUnblockContact: 'Невозможно разблокировать контакт. {{error}}',
  blockingContact: 'Блокировка {{name}}.',
  unableToBlockContact: 'Невозможно заблокировать контакт. {{error}}',
  cantAddContactToAlarmBecauseBlocked:
    'Вы заблокировали {{name}}. Разблокируйте их, чтобы добавить в качестве участника тревоги.',
  cantAddContactToGroupBecauseBlocked:
    'Вы заблокировали {{name}}. Разблокируйте их, чтобы добавить в группу.',
  sendMessageNotAllowedForPastAlarms:
    'Сообщения не могут быть отправлены для неактивных сигналов тревоги.',
  nameIsRequired: 'Имя обязательно.',
  confirmDisableGroupAlarm:
    'Отключение группового сигнала тревоги приведет к отключению сигнала тревоги и для других участников. Продолжить?',
  removeMemberFromGroup: 'Вы хотите удалить {{name}} из этой группы?',
  leaveGroupConfirm: 'Вы хотите покинуть эту группу?',
  deviceOffline:
    'Устройство находится в автономном режиме. Убедитесь, что вы подключены к Интернету, и повторите попытку.',
  cantUpdateGroupDefaulConfigWhenOffline:
    'Измененная конфигурация группы не будет применяться к последующим сигналам тревоги, поскольку устройство находится в автономном режиме.',
  specifyFeedback: 'Необходима обратная связь.',
  specifyEmailId: 'Адрес электронной почты обязателен.',
  specifyValidEmailId: 'Адрес электронной почты недействителен.',
  specifyProblem: 'Требуется описание проблемы.',
  appInstalledUsingSameNumberOnDifferentPhone:
    'Вы установили Galarm на другое устройство, используя тот же номер. Приложение на этом устройстве сброшено.',
  invalidUid:
    'Эта учетная запись пользователя больше не существует. Приложение Galarm на этом устройстве сброшено.',
  accountDeleted: 'Ваша учетная запись была удалена.',
  deleteAccount: 'Удалить мою учетную запись',
  deletingAccount: 'Удаление вашей учетной записи',
  howCanWeImprove: 'Нам жаль, что вы уходите. Как мы можем улучшить ситуацию?',
  noMusicAlert: 'Музыкальные файлы не найдены.',
  noLongerAvailableMusic:
    '{{fileName}} больше не доступен. Мелодия была изменена на {{defaultRingtoneName}}',
  userInactiveTitle: 'С возвращением!',
  userInactiveMessage:
    'Создавайте будильники для важных дел и никогда не пропускайте их.',
  createAlarm: 'Создать сигнал тревоги',
  updatedAppAvailable: 'Вышла новая версия приложения.',
  alarmOccurrenceDisabled: 'Отключено для этого случая',
  ownAlarmOccurrenceDone: {
    zero: 'Отмечено в {{timeString}}',
    one: 'Отмечено на {{timeString}} на {{dateString}}'
  },
  ownAlarmOccurrenceSkipped: {
    zero: 'Пропущено в {{timeString}}',
    one: 'Пропущено на {{timeString}} на {{dateString}}'
  },
  enabledAlarmsCount: {
    one: 'Включен 1 сигнал тревоги.',
    other: '{{count}} включена сигнализация.'
  },
  enabledAndNotEnabledAlarmsCount: {
    one: '1 сигнал тревоги включен. Сигналы тревоги без будущих событий остаются отключенными.',
    other:
      '{{count}} тревоги включены. Сигналы тревоги без будущих событий остаются отключенными.'
  },
  disabledAlarmsCount: {
    one: '1 тревога отключена.',
    other: '{{count}} отключение сигналов тревоги.'
  },
  ownAlarmOccurrenceUnacknowledged: 'Не ответили',
  participantAlarmOccurrenceDone: {
    zero: 'Отмечено {{participantName}} на {{timeString}}',
    one: 'Отмечено выполнено {{participantName}} на {{timeString}} на {{dateString}}'
  },
  participantAlarmOccurrenceSkipped: {
    zero: 'Пропущено: {{participantName}} на {{timeString}}',
    one: 'Пропущено: {{participantName}} на {{timeString}} on {{dateString}}'
  },
  participantAlarmOccurrenceUnacknowledged: '{{participantName}} не ответил',
  groupAlarmOccurrenceConfirmed: {
    zero: 'Подтверждено в {{timeString}}',
    one: 'Подтверждено на сайте {{timeString}} {{dateString}}'
  },
  groupAlarmOccurrenceDeclined: {
    zero: 'Отказано в {{timeString}}',
    one: 'Отклонено на {{timeString}} на {{dateString}}'
  },
  warning: 'Внимание',
  info: 'Информация',
  confirm: 'Подтвердите',
  error: 'Ошибка',
  cantUploadImage: 'Невозможно загрузить изображение',
  cantDeleteImage: 'Невозможно удалить изображение',
  cantEditGroup: 'Невозможно редактировать группу',
  cantAddNewContact: 'Невозможно добавить новый контакт',
  cantDeleteContact: 'Невозможно удалить контакт',
  cantEditContact: 'Невозможно отредактировать контакт',
  cantSaveAlarm: 'Невозможно спасти тревогу',
  cantSaveGroup: 'Невозможно сохранить группу',
  cantReloadContacts: 'Невозможно перезагрузить контакты',
  cantTakePhoto: 'Невозможно сделать фото',
  cantExportToCalendar: 'Невозможно экспортировать в календарь',
  cantOpenPhotoLibrary: 'Невозможно открыть библиотеку фотографий',
  cantDeleteAlarmHistory: 'Невозможно удалить историю тревог',
  cannotDuplicateAlarm: 'Невозможно продублировать сигнал тревоги',
  upgradeToPremiumToDuplicateAlarm:
    'Обновите версию до Premium, чтобы создавать больше групповых и дружеских оповещений.',
  confirmAcceptAlarm: 'Принять сигнал тревоги?',
  confirmRejectAlarm: 'Тревога спада?',
  deleteAlarm: 'Удалить сигнал тревоги?',
  restoreAlarmConfirmation: 'Восстановить сигнализацию?',
  respondToRepeatingAlarm: {
    zero: 'Вы добавлены в качестве получателя сигнала {{alarmName}} по адресу {{alarmCreatorName}}. Вы будете оповещены по адресу {{alarmTimeString}} {{alarmRepetitionString}} начиная с {{alarmDateString}}',
    one: 'Вы добавлены в качестве участника для оповещения {{alarmName}} по адресу {{alarmCreatorName}}. Вы будете оповещены по адресу {{alarmTimeString}} {{alarmRepetitionString}} начиная с {{alarmDateString}}'
  },
  respondToOneTimeAlarm: {
    zero: 'Вы добавлены в качестве получателя сигнала {{alarmName}} на {{alarmCreatorName}}. Вы будете оповещены по адресу {{alarmTimeString}} {{alarmDateString}}',
    one: 'Вы добавлены в качестве участника для оповещения {{alarmName}} по адресу {{alarmCreatorName}}. Вы будете оповещены по адресу {{alarmTimeString}} {{alarmDateString}}'
  },
  cantMoveMemberUp: 'Невозможно двигаться {{name}} вверх',
  cantMoveMemberDown: 'Невозможно двигаться {{name}} вниз',
  decline: 'Упадок',
  cantEditProfile: 'Невозможно редактировать профиль',
  cantSelectContact: 'Невозможно выбрать контакт',
  cantSendMessage: 'Невозможно отправить сообщение',
  cantSendVerificationCode: 'Невозможно отправить код проверки',
  confirmBlockContactTitle: 'Подтверждение контакта с блоком',
  confirmUnblockContactTitle: 'Подтвердить разблокировать контакт',
  cantSaveProfile: 'Невозможно сохранить профиль',
  cantBlockContact: 'Невозможно заблокировать контакт',
  cantUnblockContact: 'Невозможно разблокировать контакт',
  cantLoadEarlierMessages: 'Невозможно загрузить предыдущие сообщения',
  cantRestoreAlarm: 'Невозможно восстановить сигнализацию',
  cantSendFeedback: 'Невозможно отправить отзыв',
  cantSubmitProblem: 'Невозможность отправки',
  cantDeletePastAlarmsInBulk:
    'Невозможно удалить неактивные сигналы тревоги в массовом порядке',
  cantAddNewGroup: 'Невозможно добавить новую группу',
  alreadySnoozing: 'Уже дремлет',
  markAlarmUndone:
    "Вы отметили этот сигнал 'Выполнено' {{durationString}} назад. Отменить?",
  markAlarmUnskipped:
    'Вы пропустили этот сигнал {{durationString}} назад. Отменить?',
  cantUndo: 'Невозможно отменить',
  fetchMusicFromPhone: 'Поиск доступной музыки.',
  enableAllAlarmsInCategory: 'Включить все сигналы тревоги в этой категории?',
  disableAllAlarmsInCategory: 'Отключить все сигналы тревоги в этой категории?',
  allAlarmsAlreadyEnabled: 'Все сигналы тревоги в этой категории уже включены.',
  allAlarmsAlreadyDisabled:
    'Все сигналы тревоги в этой категории уже отключены.',
  time: 'Время',
  timeForBuddy: 'Время для приятеля',
  timeForYou: 'Напомните мне',
  name: 'Имя',
  title: 'Название',
  notes: 'Примечания',
  repeat: 'Повторите',
  preReminder: 'Предварительное напоминание',
  remove: 'Удалить',
  preReminderShortAlert: '{{duration}} Предварительное напоминание',
  preReminderTitle: '{{alarmName}} на {{date}}',
  preReminderGroupHelperText:
    'Это предварительное напоминание предназначено только для вас. Другие участники будильника могут установить свои собственные предварительные напоминания, как только получат сигнал.',
  addPreReminder: 'Добавить предварительное напоминание',
  helperTextForPreReminder:
    'Нажмите кнопку сброса в верхней части, чтобы удалить предварительное напоминание.',
  edit: 'Редактировать',
  delete: 'Удалить',
  creator: 'Создатель',
  useAsDefaultGroupConfiguration: 'Применить к будущим сигналам тревоги',
  done: 'Готово',
  skipped: 'Пропущенный',
  save: 'Сохранить',
  members: 'Члены',
  mobileNumber: 'Номер телефона',
  enter: 'Заходите на',
  addMembers: 'Добавить участников',
  respond: 'Ответить',
  yes: 'Да',
  no: 'Нет',
  cancel: 'Отмена',
  participants: 'Участники',
  takePhoto: 'Сделать фото',
  chooseFromLibrary: 'Выберите из библиотеки',
  resendCode: 'Код повторной отправки',
  register: 'Регистрация',
  inviteFriends: 'Поделиться этим приложением',
  invite: 'Пригласите',
  incorrectNumber: 'Неправильный номер?',
  date: 'Дата',
  cascadingAlarmInterval: 'Время между оповещениями участников',
  ringParticipantAlarmsByDefault: 'Звонок тревоги без принятия',
  alarmRingtone: 'Мелодия будильника',
  pickASong: 'Выберите музыку из телефона',
  privacyPolicy: 'Политика конфиденциальности',
  sendFeedback: 'Обратная связь',
  galarmWeb: 'Galarm Web',
  galarmEnterprise: 'Галарм Про',
  galarmAdmin: 'Администратор Галарм',
  troubleshooting: 'Устранение неполадок',
  alarmDidntRingHelp: 'Помогите! Мой будильник не зазвонил',
  autoStartSettingHelperText:
    'Если в вашем телефоне есть настройка автозапуска, убедитесь, что автозапуск включен для Galarm.',
  batteryOptimizationHelperText: 'Отключите оптимизацию батареи для Galarm',
  troubleshootingHelperText:
    'Следующие настройки могут не позволять будильникам звонить, как положено. Пожалуйста, проверьте эти настройки.',
  getMoreHelpText: 'У вас все еще проблемы?',
  autoStartSetting: 'Автоматический запуск',
  batteryOptimization: 'Оптимизация работы аккумулятора',
  battery: 'Аккумулятор',
  rateTheAppSettings: 'Оцените это приложение',
  about: 'Информация и помощь',
  leaveGroup: 'Группа отпусков',
  removeGroup: 'Удалить группу',
  viewMember: 'Посмотреть {{memberName}}',
  removeMember: 'Удалить {{memberName}}',
  changeMemberState: 'Изменить, кто может оповещать {{memberName}}',
  changeYourGroupState: 'Измените, кто может предупреждать вас',
  numMembersInGroup: 'Члены: {{count}}',
  notifications: 'Уведомления приложений отключены',
  backgroundAppRefresh: 'Обновление приложений в фоновом режиме отключено',
  groupsInCommon: 'Общие группы',
  alarmsInCommon: 'Общие тревоги',
  close: 'Закрыть',
  responsePending: 'Ваша реакция?',
  later: 'Позже',
  install: 'Установите',
  all: 'Все',
  numYears: { one: '1 год', other: '{{count}} лет' },
  numMonths: { one: '1 месяц', other: '{{count}} месяцев' },
  numDays: { one: '1 день', other: '{{count}} дней' },
  hours: { one: '1 час', other: '{{count}} часы' },
  minutes: { one: '1 минута', other: '{{count}} минут' },
  seconds: { one: '1 секунда', other: '{{count}} секунды' },
  minutesSmall: '{{count}} мин',
  secondsSmall: '{{count}} сек',
  hoursAfter: {
    one: 'Через 1 час после',
    other: '{{count}} через несколько часов после'
  },
  minutesAfter: {
    one: 'Через 1 минуту после',
    other: '{{count}} через несколько минут после'
  },
  hoursAfterBuddy: {
    one: 'Через 1 час после приятеля',
    other: '{{count}} через несколько часов после приятеля'
  },
  minutesAfterBuddy: {
    one: 'Через 1 минуту после приятеля',
    other: '{{count}} через несколько минут после того, как приятель'
  },
  longerThanAnHour: '> 1 час',
  licenses: 'Лицензирование третьими сторонами',
  version: 'Версия',
  termsOfService: 'Условия предоставления услуг',
  showPrivacyPolicy: '> Политика конфиденциальности',
  showTermsOfService: '> Условия предоставления услуг',
  showLicenses: '> Лицензирование третьих лиц',
  change: 'Изменить',
  snooze: 'Snooze',
  ringOnVibrate: 'Звонок на беззвучном режиме',
  vibrate: 'Вибрация',
  ringOnEarphoneOnly: 'Звонок будильника только для наушников',
  ringOnSpeakerAndEarphone: 'Звонок будильника на динамик и наушники',
  whenEarphoneIsConnected: 'Если подключены наушники',
  tapGesture: 'Нажмите',
  slideGesture: 'Слайд',
  silent: 'Молчание',
  volume: 'Объем',
  soundAndVibration: 'Звук и вибрация',
  advancedSettings: 'Дополнительные настройки',
  gestureToDismissAnAlarm: 'Жест для отключения сигнала тревоги',
  someNotificationsAreMuted: 'Некоторые уведомления отключены',
  allNotificationsEnabled: 'Все уведомления включены',
  notificationSettings: 'Настройки уведомлений',
  galarmWebNotifications: 'Веб-уведомления Galarm',
  alarmsfromOthersNotifications: 'Уведомления о тревогах участников',
  sharedAlarmNotifications: 'Общие уведомления о тревоге',
  alarmChatNotifictions: 'Уведомления о тревожных чатах',
  groupNotifications: 'Групповые уведомления',
  alarmAcknowledgementNotifications:
    'Уведомления о подтверждении сигнала тревоги',
  send: 'Отправить',
  prev: 'Prev',
  snoozing: '{{timeString}}',
  specifySnoozeDuartion: 'Укажите продолжительность "пробуждения',
  chooseDifferentDuration: 'Выберите другую продолжительность',
  noCalendarsFound: 'На устройстве не обнаружено ни одного календаря.',
  eventWillEndAt: 'Мероприятие закончится на сайте {{timeString}}.',
  selectDurationWithinTheSameDay: 'Событие не может пересечь границу дня.',
  cannotMapRepeatTypeInTheDeviceCalendar:
    'Невозможно "Экспортировать в календарь", потому что настройка "Повтор" вашего будильника не поддерживается календарем.',
  alarmSavedToCalendar: 'Будильник успешно сохранен в календаре.',
  faq: 'Часто задаваемые вопросы',
  openSettings: 'Открыть настройки',
  openAppSettings: 'Откройте Настройки приложения',
  alreadyDone: 'Готово',
  enableAutoStart: 'Включить автозапуск',
  restrictedApps: 'Ограниченные приложения',
  unmonitoredApps: 'Неконтролируемые приложения',
  enableProtected: 'Защищенные приложения',
  manageAppLaunch: 'Управление запуском приложений',
  unblockContact: 'Разблокировать контакт',
  blockContact: 'Блок-контакт',
  call: 'Звоните на {{name}}',
  text: 'Текст {{name}}',
  chat: 'Чат',
  ok: 'OK',
  stopSnooze: 'Остановить дремоту',
  emailId: 'Ваш адрес электронной почты',
  feedback: 'Обратная связь',
  submit: 'Отправить',
  reportAProblem: 'Сообщить о проблеме',
  enableAlarm: 'Включить сигнализацию',
  restoreAlarm: 'Восстановление тревоги',
  deletePastAlarms: 'Удаление неактивных сигналов тревоги',
  accept: 'Принять',
  defaultPersonalAlarmName: 'Персональное напоминание',
  defaultGroupAlarmName: 'Групповое мероприятие',
  defaultRecipientAlarmName: 'Будильник',
  search: 'Поиск',
  recent: 'Последние',
  upcoming: 'Предстоящий',
  missed: 'Пропущенный',
  expired: 'Просроченный',
  past: 'Прошлое',
  active: 'Активный',
  inactive: 'Неактивный',
  allAlarms: 'Все сигналы тревоги',
  myAlarms: 'Мои сигналы тревоги',
  participantAlarms: 'Сигналы тревоги для участников',
  pendingParticipantAlarms: 'Новые сигналы тревоги от других людей',
  alarmsWithUnreadChatMessages: 'Сигналы тревоги с новым чатом',
  systemNotifications: 'Системные сообщения',
  missedAlarms: 'Пропущенные сигналы тревоги',
  recentlyDeletedAlarms: 'Недавно удаленные сигналы тревоги',
  searchAlarms: 'Поиск сигналов тревоги',
  participant: 'Участник',
  you: 'Вы',
  none: 'Нет',
  onceOnly: 'Только один раз',
  weekdays: 'Будни',
  weekends: 'Выходные',
  everyDayString: 'Ежедневно',
  everySunday: 'Каждое воскресенье',
  everyMonday: 'Каждый понедельник',
  everyTuesday: 'Каждый вторник',
  everyWednesday: 'Каждую среду',
  everyThursday: 'Каждый четверг',
  everyFriday: 'Каждую пятницу',
  everySaturday: 'Каждую субботу',
  sunday: 'Воскресенье',
  monday: 'Понедельник',
  tuesday: 'Вторник',
  wednesday: 'Среда',
  thursday: 'Четверг',
  friday: 'Пятница',
  saturday: 'Суббота',
  january: 'Январь',
  february: 'Февраль',
  march: 'Март',
  april: 'Апрель',
  may: 'Май',
  june: 'Июнь',
  july: 'Июль',
  august: 'Август',
  september: 'Сентябрь',
  october: 'Октябрь',
  november: 'Ноябрь',
  december: 'Декабрь',
  jan: 'Янв',
  feb: 'Фев',
  mar: 'Мар',
  apr: 'Апр',
  shortMay: 'Май',
  jun: 'Июн',
  jul: 'Июл',
  aug: 'Авг',
  sep: 'Сен',
  oct: 'Окт',
  nov: 'Ноя',
  dec: 'Дек',
  sun: 'Вс',
  mon: 'Пн',
  tue: 'Вт',
  wed: 'Ср.',
  thu: 'Чт',
  fri: 'Пн',
  sat: 'Сб',
  first: '1-й',
  second: '2-й',
  third: '3-й',
  fourth: '4-й',
  fifth: '5-й',
  every: 'Каждый',
  oddNumberedDays: 'Нечетные даты',
  evenNumberedDays: 'Четные даты',
  noParticipants: 'Нет участников',
  typeYourMessage: 'Напечатайте свое сообщение',
  cantPostMessageToPastAlarm:
    'Невозможно опубликовать сообщение для неактивного будильника',
  groupName: 'Группа: {{name}}',
  alarm: 'Сигнал тревоги',
  confirmed: 'подтверждено',
  declined: 'отказался',
  Done: 'Готово',
  Skip: 'Скип',
  Confirm: 'Подтвердите',
  Decline: 'Упадок',
  Accept: 'Принять',
  today: 'сегодня',
  on: 'на',
  recipientAlarm: 'Будильник',
  recipient: 'Получатель',
  remindMeAfter: 'Напомните мне',
  remindMeIn: 'Напомните мне в',
  newRecipientAlarm: 'Новая сигнализация для приятелей',
  editRecipientAlarm: 'Редактировать Buddy Alarm',
  newInstantAlarm: 'Новая мгновенная сигнализация',
  instantAlarms: 'Мгновенные сигналы тревоги',
  alarmDone: 'Сигнал тревоги отмечен как выполненный',
  alarmSkipped: 'Сигнал тревоги пропущен',
  undo: 'Отменить',
  enterVerificationCode: 'Пожалуйста, введите 4-значный код ниже:',
  initializing: 'Инициализация',
  tryAgain: 'Попробуйте еще раз',
  nMore: '+ {{count}} подробнее',
  enableNotification: 'Включить',
  enableAlarmNotificationChannel: 'Включить',
  enableBackgroundAppRefresh: 'Включить',
  viewImpactedAlarms: 'Сигналы тревоги',
  viewImpactedGroups: 'Группы',
  dismiss: 'Увольте',
  minsInterval: '+ {{count}}m',
  hoursInterval: '+ {{count}}h',
  daysInterval: '+ {{count}}d',
  snoozeUnitHours: 'Часы',
  snoozeUnitMinutes: 'Протоколы',
  snoozeUnitDays: 'Дни',
  selectMinutes: 'Выберите минуты',
  selectHours: 'Выберите часы',
  selectDays: 'Выберите дни',
  selectHoursAndMinutes: 'Выберите часы и минуты',
  enterDuration: 'Продолжительность',
  snoozeUnit: 'Единица',
  specifySnoozeUnit: 'Укажите единицу времени ожидания',
  specifySnoozeDuration: 'Укажите продолжительность "пробуждения',
  duration: 'Продолжительность',
  quickAlarmName: {
    zero: '{{minutes}} минимальное напоминание',
    one: '{{hours}} часовое напоминание',
    other: '{{hours}} час {{minutes}} мин. напоминание'
  },
  alarmTitleForGoogleVoiceTimerCommand: '{{durationString}} напоминание',
  addedAlarmFromVoiceCommand:
    'Добавлена сигнализация для {{alarmName}} на {{dateString}}',
  addedTimerFromVoiceCommand: 'Добавлен таймер для {{duration}}',
  clear: 'Очистить',
  ringtoneDuration: 'Продолжительность мелодии',
  newAlarm: 'Новая сигнализация',
  quickAlarm: 'Быстрое напоминание',
  quickAlarmWillRingAt: 'Сигнал тревоги прозвучит на сайте {{timeString}}.',
  random: 'Случайный',
  enableAllAlarms: 'Включить все сигналы тревоги',
  disableAllAlarms: 'Отключить все сигналы тревоги',
  deleteAllAlarms: 'Удалить все сигналы тревоги',
  hideCategory: 'Скрыть категорию',
  unhideCategory: 'Скрыть категорию',
  dontShowHiddenCategories: 'Не показывать скрытые категории',
  showHiddenCategories: 'Показать скрытые категории',
  welcomeAlarmsTitle: 'Давайте начнем!',
  welcomeAlarmsMessage: 'Вот некоторые часто используемые сигналы тревоги:',
  onboardingAlarms: 'Сигналы тревоги при входе в систему',
  hiddenAlarmCategories: 'Скрытые категории',
  restorePurchases: 'Восстановление покупок',
  noAvailablePurchasesFound:
    'Для вашего аккаунта не найдено доступных покупок.\n\nПожалуйста, отправьте нам отзыв через "Настройки > Обратная связь", если у вас есть действительная покупка, которую вы не можете восстановить.',
  restoringPurchases: 'Восстановление покупок',
  fetchingContacts: 'Проверка того, какие контакты используют Galarm',
  enterNameAndUploadPhotoForUser:
    'Введите свое имя и, по желанию, загрузите фотографию профиля.',
  enterNameAndUploadPhotoForGroup:
    'Введите название и по желанию загрузите групповую фотографию.',
  noContactsWithAppInstalled: 'Никто из ваших контактов не использует Galarm.',
  galarmContacts: {
    one: '1 контакт Галарм',
    other: '{{count}} Контакты Галарм'
  },
  contactsPendingInvitation: {
    one: '1 ожидающее приглашение',
    other: '{{count}} ожидающие приглашения'
  },
  otherContacts: {
    one: '1 другой контакт',
    other: '{{count}} другие контакты'
  },
  over100Contacts: 'Более 100 других контактов',
  noAlarms:
    'У вас нет ни одного будильника. Нажмите +, чтобы добавить новый будильник.',
  noContactsWeb: {
    one: 'Мы не нашли ни одного контакта, использующего Galarm. Либо у нас нет разрешения на доступ к вашим контактам, либо никто из ваших контактов не использует Galarm. Вы можете синхронизировать контакты из мобильного приложения.\n\nВы можете добавить контакты, использующие Galarm, в свои будильники различными способами, чтобы воспользоваться преимуществами приложения',
    other:
      'Зарегистрируйтесь в мобильном приложении, чтобы начать добавлять контакты в будильники.'
  },
  viewingAlarmsInCommon: 'Сигналы тревоги, общие с {{name}}',
  viewingGroupsInCommon: 'Группы, общие с {{contactName}}',
  changeGroupMemberConfigTextForCascadingAlarm:
    'Активные участники будут оповещены в указанном порядке.',
  changeGroupMemberConfigTextForSimultaneousAlarm:
    'Оповещения будут приходить только активным участникам.',
  changeGroupMemberStateText: {
    zero: 'Измените участников, которые могут оповещать вас о создании сигнала тревоги для группы "{{groupName}}".\n\nВы будете получать уведомления только в том случае, если тревога создана разрешенными участниками.',
    one: 'Измените членов, которые могут оповещать {{memberName}} о создании сигнала тревоги для группы "{{groupName}}".\n\n{{memberName}} будут оповещены только в том случае, если тревога создана разрешенными участниками.'
  },
  allowed: 'Разрешено',
  notAllowed: 'Не разрешено',
  changeStatus: 'Разрешенные члены',
  noUpcomingAlarms: 'Никаких предстоящих тревог',
  showMore: 'Показать еще',
  nMorePastAlarms: {
    one: 'Еще 1 неактивный сигнал тревоги',
    other: '{{count}} больше неактивных сигналов тревоги'
  },
  shareAppMessage:
    'Я делаю все свои дела вовремя, создавая для них напоминания с помощью приложения Galarm. С помощью этого приложения мы также можем включать друг друга в наши напоминания. Я рекомендую загрузить это инновационное приложение для будильников и напоминаний. {{downloadLink}}',
  addingMembers: 'Добавление участников.',
  unableToAddMembers: 'Невозможно добавить участников. {{error}}',
  removingMember: 'Удаление участника.',
  unableToRemoveMember: 'Невозможно удалить участника. {{error}}',
  leavingGroup: 'Уходящая группа.',
  unableToLeaveGroup: 'Невозможно покинуть группу. {{error}}',
  expiredPersonalAlarmForCreator: {
    zero: 'Срок действия этого сигнала истек {{durationString}} назад. Нажмите "Готово", чтобы завершить будильник.',
    one: 'Срок действия этого сигнала истек {{durationString}} назад. Нажмите "Готово", чтобы завершить оповещение и уведомить участников.',
    other:
      'Срок действия этого сигнала истек {{durationString}} назад. Нажмите "Готово", чтобы завершить оповещение и уведомить участников.'
  },
  donePersonalAlarmForCreator:
    'Срок действия этой сигнализации истек {{durationString}} назад. Сигнал тревоги отмечен как выполненный.',
  skippedPersonalAlarmForCreator:
    'Срок действия этой сигнализации истек {{durationString}} назад. Вы пропустили сигнал тревоги.',
  expiredGroupAlarm:
    'Срок действия этой сигнализации истек {{durationString}} назад. Пожалуйста, подтвердите свое участие.',
  expiredPersonalAlarmForParticipant:
    'Срок действия этой сигнализации истек {{durationString}} назад. Пожалуйста, напомните {{creatorName}}.',
  alarmDurationAndroid:
    'Будильник установлен на {{durationString}} с этого момента.',
  alarmDurationIos:
    'Будильник установлен на {{durationString}} с этого момента.',
  alarmFeedbackHeader:
    'Вы будете отправлять часть информации об этой тревоге в целях отладки. Любые личные данные, такие как название тревоги, заметки или участники, не будут переданы.',
  privacyPolicyHeader:
    'Уважение к вашей конфиденциальности постоянно тикает в наших часах. Как и вы, мы ценим конфиденциальность, поэтому хотим, чтобы вы знали, что мы не передаем вашу личную информацию никому, за исключением случаев, когда это необходимо для установки приложения или когда это требуется по закону. В любом случае мы никогда не продадим вашу информацию. Все просто!\n \nСозданные вами тревоги можно просматривать только на вашем устройстве и, если в тревоге участвуют другие участники, на устройствах этих участников.\n \nМы обращаемся к адресной книге/списку контактов вашего телефона только для заполнения вкладки контактов в Galarm. Мы не храним этот список для каких-либо других целей. Мы чтим то, что это ваша адресная книга!\n \nМы получаем доступ к вашей камере и фотографиям только для того, чтобы вы могли установить хорошую фотографию профиля. Эта фотография будет отображаться как ваш аватар или как фотография профиля группы, которую вы редактируете. Другие пользователи Galarm, которые являются членами установленных вами оповещений, смогут видеть эту фотографию.\n\nМы отправляем публичный IP-адрес вашего устройства и его уникальный идентификатор при всех запросах, например, при запросе и проверке кода в процессе регистрации. Эта информация не связана с вашей учетной записью и используется только для определения возможной вредоносной активности.\n \nПожалуйста, ознакомьтесь с полной политикой конфиденциальности для получения более подробной информации о том, какую информацию мы собираем и как мы ее используем.',
  termsOfServiceHeader:
    'Используя приложение Galarm, вы соглашаетесь с нашими Условиями предоставления услуг, которые регулируют ваш доступ и использование этого мобильного приложения, а также предлагаемых им функций и услуг. \n\nДевиз Galarm прост - помочь вам не пропустить ни одного события!  Будь то установка персональных будильников для оповещения о пробуждении, своевременном назначении встреч и напоминаний о приеме лекарств, или создание групповых будильников для организации групповых мероприятий, таких как походы в кино, спортивные мероприятия и вечеринки, Galarm позволяет вам иметь социальный будильник для напоминания друг другу, отслеживания статуса и общения друг с другом.\n\nПожалуйста, используйте Galarm только в том случае, если вы согласны с этими условиями. Ниже приведена ссылка на них.',
  acknowledgedPersonalAlarm:
    'Вы отметили сигнал тревоги "Выполнено" {{durationString}} назад.',
  skippedPersonalAlarm: 'Вы пропустили сигнал {{durationString}} назад.',
  authenticatingWithServer: 'Подключение...',
  selectParticipantsForPersonalAlarm:
    'Выберите группу или набор людей, которые будут выступать в качестве резервных копий вашей персональной сигнализации.',
  selectParticipantsForGroupAlarm:
    'Выберите группу или группу людей для группового занятия.',
  acknowledgedGroupAlarm:
    'Вы {{acknowledgedAsString}} эту сигнализацию {{durationString}} назад.',
  acknowledgedExpiredGroupAlarm:
    'Срок действия этой сигнализации истек {{durationString}} назад. Вы {{acknowledgedAsString}} этот сигнал.',
  acknowledgedPersonalAlarmForParticipant:
    '{{creatorName}} пометил будильник "Готово" {{durationString}} назад.',
  acknowledgedExpiredPersonalAlarmForParticipant:
    'Срок действия этого сигнала истек {{durationString}} назад. {{creatorName}} отметил сигнал "Выполнен".',
  entityNotFound:
    'Упс! Мы не смогли найти выбранный сайт {{entityType}}. Возможно, мы все еще ищем его или он был удален.',
  goBack: 'Вернуться',
  uploadingImageToServer: 'Загрузка изображения на сервер.',
  deletingImageFromServer: 'Удаление изображения с сервера',
  errorUploadingImageToServer:
    'Ошибка при загрузке изображения на сервер. Пожалуйста, повторите попытку позже.',
  unableToRemoveGroup: 'Невозможно удалить группу. {{error}}',
  addingGroup: 'Добавление группы.',
  editingGroup: 'Группа редактирования.',
  unableToAddGroup: 'Невозможно добавить группу. {{error}}',
  unableToEditGroup: 'Невозможно отредактировать группу. {{error}}',
  thanksForFeedback: 'Спасибо, что помогаете нам совершенствоваться.',
  licensesHeader:
    'Galarm включает в себя программное обеспечение, лицензированное третьими сторонами. Соответствующую информацию об авторстве и лицензировании см. на странице "Лицензирование третьих лиц".',
  alarmAlreadyInSnooze: 'Вы получите напоминание на сайте {{durationString}}.',
  carrierChargesMayApply: 'Возможна оплата услуг перевозчика.',
  selectCascadingInterval:
    'Первый участник будет оповещен через {{firstParticipantDurationString}} после времени сигнала, второй - через {{secondParticipantDurationString}} и так далее, если вы не отметите сигнал как выполненный.',
  reorderParticipantsScreenDescription:
    'Участники будут оповещены в указанном порядке.',
  noMembers: 'Нет членов',
  selectedGroupDescription: {
    zero: '{{numActiveMembers}} участники',
    one: '{{numActiveMembers}} активный и {{numInactiveMembers}} неактивный участник',
    other:
      '{{numActiveMembers}} активные и {{numInactiveMembers}} неактивные участники'
  },
  groupAlarmWillRingAtSameTime:
    'Все участники будут оповещены на сайте {{timeString}}.',
  welcomeToGalarm: 'Добро пожаловать в Галарм',
  checkingConnection: 'Проверка соединения',
  deletePastAlarmsTitle: 'Удаление неактивных сигналов тревоги старше',
  deletePastAlarmsOption: {
    zero: '{{option}} (0 тревог)',
    one: '{{option}} (1 сигнал тревоги)',
    other: '{{option}} ({{count}} alarms)'
  },
  chooseSnoozeInterval: 'Напомните мне еще раз в',
  personalAlarmDescription:
    'Используйте личный будильник, чтобы проснуться, принять лекарство или выполнить любое другое задание для себя. При желании можно добавить участников, которые будут оповещены, если вы пропустите будильник, чтобы они могли напомнить вам. Участники также получают уведомление, когда вы отмечаете будильник выполненным.',
  groupAlarmDescription:
    'Используйте групповой будильник для групповых мероприятий, таких как выезды, вечеринки или любые другие события. Будильник срабатывает в одно и то же время для всех участников, и они могут подтвердить свое участие.',
  recipientAlarmDescription:
    'Создайте будильник для другого человека ("приятеля"), чтобы напомнить ему о делах, которые ему нужно сделать. Вы получите уведомление, чтобы напомнить приятелю, если он пропустит сигнал. Вы также получите уведомление, когда приятель отметит будильник выполненным.\n  \nОбратите внимание, что будильники создаются в вашем часовом поясе.',
  whatsThis: 'Что это?',
  alarmCurrentlyDisabled: 'В настоящее время этот сигнал отключен',
  alarmCurrentlyRejected: 'Этот сигнал тревоги в настоящее время отклонен',
  currentlyTypingUsers: {
    one: '{{currentlyTypingUsers}} печатает...',
    other: '{{currentlyTypingUsers}} набирают...'
  },
  noSearchResultsFound: 'Не найдено {{type}} ',
  noGroupsCreated: 'Вы не создали ни одной группы.',
  noGroupsWeb: {
    one: 'Вы не создали ни одной группы.',
    other:
      'Зарегистрируйтесь в мобильном приложении, чтобы начать создавать группы и добавлять их в оповещения.'
  },
  internalErrorDuringRegistration:
    'При регистрации пользователя произошла внутренняя ошибка. Пожалуйста, повторите попытку через несколько минут',
  selectRecipientAlarmInterval: {
    zero: 'Вы получите уведомление одновременно с получателем.',
    one: 'Если получатель не отметил будильник "Готово", вы получите уведомление по адресу {{durationString}}.',
    other:
      'Если получатель не отметил будильник "Готово", вы получите уведомление по адресу {{durationString}}.'
  },
  selectRecipient: 'Выберите получателя',
  acknowledgedExpiredRecipientAlarm:
    'Срок действия этого сигнала истек {{durationString}} назад. Вы отметили этот сигнал "Выполнен".',
  skippedExpiredRecipientAlarm:
    'Срок действия этой сигнализации истек {{durationString}} назад. Вы пропустили этот сигнал.',
  expiredRecipientAlarm:
    'Срок действия этого сигнала истек {{durationString}} назад. Нажмите "Готово", чтобы завершить сигнализацию и уведомить {{creatorName}}.',
  acknowledgedRecipientAlarm:
    'Вы отметили этот сигнал "Выполнено" {{durationString}} назад.',
  skippedRecipientAlarm: 'Вы пропустили этот сигнал {{durationString}} назад.',
  acknowledgedExpiredRecipientAlarmForCreator:
    'Срок действия этого сигнала истек {{durationString}} назад. {{recipientName}} отметил сигнал "Выполнен".',
  skippedExpiredRecipientAlarmForCreator:
    'Срок действия этой сигнализации истек {{durationString}} назад. {{recipientName}} пропустил сигнал.',
  expiredRecipientAlarmForCreator:
    'Срок действия этой сигнализации истек {{durationString}} назад. Пожалуйста, напомните {{recipientName}}.',
  acknowledgedRecipientAlarmForCreator:
    '{{recipientName}} пометил будильник "Готово" {{durationString}} назад.',
  selectRecipientForRecipientAlarm: 'Выберите получателя сигнала тревоги',
  selectAtLeastOneParticipantForGroupAlarm:
    'Добавьте хотя бы одного участника к сигналу тревоги',
  addAtLeastOneMemberToGroup: 'Добавьте в группу хотя бы одного участника',
  atTheSameTime: 'В то же время',
  myself: 'Я сам',
  group: 'Группа',
  someoneElse: 'Кто-то другой',
  participantsAreNotified: 'Участники получают уведомления.',
  creatorIsNotified: '{{creatorName}} уведомлен.',
  membersAddedToGroup: {
    one: '{{memberNames}} добавляется в группу {{groupName}}.',
    other: '{{memberNames}} добавляются в группу {{groupName}}.'
  },
  memberRemovedFromGroup:
    '{{memberName}} удалена из группы {{groupName}}, что могло повлиять на некоторые ваши оповещения.',
  youRemovedFromGroup:
    'Вы удалены из группы {{groupName}}, что могло повлиять на некоторые ваши тревоги.',
  memberLeftGroup:
    '{{memberName}} левая группа {{groupName}}, что могло повлиять на некоторые ваши сигналы тревоги.',
  youLeftGroup:
    'Вы покинули группу {{groupName}}, что могло повлиять на некоторые из ваших сигналов тревоги.',
  groupLeft: 'Вы покинули группу {{groupName}}.',
  memberMovedToADifferentTimezone:
    '{{memberName}} переехал в другой часовой пояс, что могло повлиять на некоторые из ваших будильников.',
  memberDstChanged: {
    zero: '{{memberName}} перестали переходить на летнее время. Соответствующие сигналы тревоги были обновлены.',
    one: '{{memberName}} перешли на летнее время. Соответствующие сигналы были обновлены.'
  },
  impactedAlarms: 'Затронутые сигналы тревоги:',
  alwaysRingParticipantAlarmsOn:
    'Будильники от других людей будут звонить, если вы не отклоните их.',
  alwaysRingParticipantAlarmsOff:
    'Сигналы тревоги от других людей не будут звонить, пока вы их не примете.',
  agreeToTermsOfServiceAndPrivacyPolicy:
    'Продолжая, вы принимаете Условия предоставления услуг и Политику конфиденциальности Galarm.',
  deleteAccountWarningHeader:
    'Внимание: Это действие необратимо. Удаление вашей учетной записи приведет к:',
  deleteAccountDeleteAlarms: '- Удалите все созданные вами сигналы тревоги',
  deleteAccountDeleteRecipientAlarms:
    '- Удалите все сообщения о приятелях, в которых вы являетесь получателем.',
  deleteAccountRemoveFromGroups: '- Удалить вас из всех групп',
  deleteAccountWarningFooter: {
    zero: 'Если вы меняете телефон, то можете просто установить приложение на новый телефон и зарегистрироваться по тому же номеру. На этом телефоне вы можете удалить приложение.\n\nПосле удаления учетной записи вы не сможете ее восстановить.',
    one: 'Если вы меняете телефон, то можете просто установить приложение на новый телефон и зарегистрироваться по тому же номеру. На этом телефоне вы можете удалить приложение.\n\nЕсли вы удалите свою учетную запись, вы не сможете ее восстановить. Вы можете управлять своей активной подпиской на Galarm в Play Store.',
    other:
      'Если вы меняете телефон, то можете просто установить приложение на новый телефон и удалить его на этом.\n\nПосле удаления учетной записи вы не сможете ее восстановить. Вы можете управлять своей активной подпиской на Galarm в App Store.'
  },
  typeConfirmationStringToDeleteAccount:
    'Введите {{confirmationString}}, чтобы удалить свою учетную запись',
  unableToDeleteAccount: 'Невозможно удалить учетную запись. {{error}}',
  impactedGroups: 'Затронутые группы:',
  memberDeletedAccount:
    '{{memberName}} удалил свою учетную запись, что могло повлиять на некоторые ваши оповещения и группы.',
  confirmCountryCodeAndEnterNumberForExistingUser:
    'Пожалуйста, подтвердите код страны и введите номер телефона, который вы использовали при регистрации ранее.',
  requiredPermissionsDisabledWarningIos:
    'Уведомления отключены. Будильники не будут звонить. Нажмите, чтобы исправить.',
  requiredPermissionsDisabledWarningAndroid:
    'У Galarm нет необходимых разрешений для звонка будильника. Нажмите, чтобы исправить.',
  notificationChannelPopupDisabledWarningAndroid:
    'Уведомления о будильниках не отображаются на экране. Нажмите, чтобы исправить.',
  alarmLockScreenNotificationDisabledWarningAndroid:
    'Уведомления о будильниках не отображаются на экране блокировки. Нажмите, чтобы исправить.',
  why: 'Почему',
  how: 'Как',
  registrationRequired: 'Требуется регистрация',
  phoneNumberRequired: 'Требуется номер телефона',
  fewSeconds: 'несколько секунд',
  lessThanMinute: 'меньше минуты',
  updateUnsupportedVersion:
    'Для продолжения использования Galarm требуется обновленная версия приложения.',
  update: 'Обновление',
  back: 'Назад',
  unableToMarkAlarmDone:
    'В данный момент не удается отметить тревогу как выполненную. Пожалуйста, повторите попытку через несколько минут.',
  unableToMarkAlarmUndone:
    'В данный момент не удается пометить тревогу как неснятую. Пожалуйста, повторите попытку через несколько минут.',
  unableToMarkAlarmUnskipped:
    'В данный момент не удается отметить тревогу как пропущенную. Пожалуйста, повторите попытку через несколько минут.',
  unableToSkipAlarm:
    'В данный момент не удается пропустить сигнал тревоги. Пожалуйста, повторите попытку через несколько минут.',
  unableToSetGroupAlarmResponse:
    'В данный момент не удается загрузить {{response}} групповой сигнал тревоги. Пожалуйста, повторите попытку через несколько минут.',
  unableToDeleteAlarm:
    'В данный момент не удается удалить сигнал тревоги. Пожалуйста, повторите попытку через несколько минут.',
  unableToSetAlarmResponse:
    'В данный момент мы не можем установить ваш ответ. Пожалуйста, повторите попытку через несколько минут.',
  unableToSnoozeAlarm: 'Невозможно перевести будильник в режим ожидания.',
  unableToStopSnoozeForAlarm:
    'Невозможно остановить повтор сигнала будильника.',
  unableToUpdateParticipantAlarmRingerSettings:
    'В данный момент не удается обновить настройки звонка. Пожалуйста, повторите попытку через несколько минут.',
  updateParticipantPreReminderDuration:
    'В данный момент невозможно обновить продолжительность предварительного напоминания. Пожалуйста, повторите попытку через несколько минут.',
  unableToUpdateAlarmRingerSettings:
    'В данный момент не удается обновить настройки звонка. Пожалуйста, повторите попытку через несколько минут.',
  unableToUpdateAlarmPreReminderDuration:
    'В данный момент невозможно обновить длительность предварительного напоминания. Пожалуйста, повторите попытку через несколько минут.',
  retrievingAlarmsFromServer: 'Получение сигналов тревоги с сервера...',
  startApp: 'Начало >',
  phoneNumberRequiredGroupListHeaderText:
    'Группа - это коллекция контактов Galarm, позволяющая быстро создавать с ними оповещения.\n\nЗарегистрируйтесь, используя свой номер телефона, чтобы найти контакты, использующие Galarm. Вы можете добавлять их в группы.',
  phoneNumberRequiredBuddyAlarmHeaderText:
    'Buddy alarm можно использовать для установки будильников для друзей и близких, чтобы напоминать им о делах, которые они должны сделать.\n\nЧтобы воспользоваться этой и многими другими функциями приложения, зарегистрируйтесь, используя свой номер телефона.',
  phoneNumberRequiredContactListHeaderText:
    'Контакты - это люди, которых можно добавлять в качестве участников оповещений.\n\nЧтобы просмотреть контакты, использующие Galarm, зарегистрируйтесь, используя свой номер телефона. Вы можете добавить их в качестве участников тревог.',
  phoneNumberRequiredGroupAlarmHeaderText:
    'Групповой будильник можно использовать для установки напоминания для группы людей.\n\nЧтобы воспользоваться этой и многими другими функциями приложения, зарегистрируйтесь, используя свой номер телефона.',
  phoneNumberRequiredParticipantsHeaderText:
    'Участники выступают в роли дублеров этого сигнала. Они напоминают, если вы пропустили сигнал тревоги.\n\nЧтобы воспользоваться этой и многими другими функциями приложения, зарегистрируйтесь, используя свой номер телефона.',
  youHaveNotRegistered:
    'В настоящее время резервное копирование ваших тревог не выполняется.\n\nПожалуйста, зарегистрируйтесь, используя свой номер телефона. После регистрации резервные копии ваших будильников будут храниться в облаке. Это позволит вам восстановить будильники и другие настройки при смене телефона.\n',
  registerNow: 'Зарегистрируйтесь сейчас',
  hoursAndMinutes: 'Часы и минуты',
  days: 'Дни',
  weeks: 'Недели',
  months: 'Месяцы',
  years: 'Годы',
  daysOfWeek: 'Еженедельно (по отдельным дням)',
  monthly: 'Ежемесячно',
  yearly: 'Ежегодно',
  everyDay: 'Ежедневно',
  selectDaysOfWeek: 'Выберите дни недели',
  alarmRingMessageForSpecificDates:
    'Этот будильник будет звонить только в те месяцы, в которых есть хотя бы {{dayOfMonth}} дней. Вы хотите продолжить?',
  alarmRingMessageForSpecificYear:
    'Этот будильник будет звонить только в високосные годы. Вы хотите продолжить?',
  alarmRingMessageForSpecificDayOfWeekInMonth:
    'Этот будильник будет звонить только в те месяцы, когда есть {{weekNumberOfDayInMonth}} {{dayName}} с. Хотите продолжить? ',
  alarmRepetitionAdjustedBasedOnNewDate:
    'Повтор сигнала тревоги был обновлен в соответствии с новой датой.',
  inviteFriendsToInstallGalarm:
    'Контакты - это люди, которые могут быть добавлены в качестве участников ваших тревог. Вы можете приглашать контакты:\n\n1. Из вашей адресной книги\n\n2. Вручную указав их имя и номер.\n\nНажмите кнопку Обновить в левом верхнем углу, чтобы перезагрузить контакты Galarm после их регистрации.',
  whyCreateNewGroup:
    'Группы - это совокупность контактов, которые можно добавить в качестве участников в ваши оповещения.\n  \nВы не создали ни одной группы.',
  noNotifications: 'У вас нет новых уведомлений.',
  createGroup: 'Создать группу',
  galarmRequiresAccessToContactsPermission:
    'Galarm запрашивает разрешение на доступ к вашим контактам. Эта информация отправляется на серверы компании для идентификации ваших контактов, использующих Galarm. Эти пользователи могут быть добавлены в качестве участников ваших тревог.',
  galarmRequiresAccessToAudioFilesPermission:
    'Некоторые будильники используют в качестве мелодии звонка музыку с телефона. Предоставьте разрешение на доступ к аудиофайлам на вашем устройстве, чтобы эти будильники звонили с выбранной мелодией.',
  galarmRequiresAccessToContactsSelectScreen:
    'У Galarm нет разрешения на доступ к контактам. Пожалуйста, разрешите доступ к контактам, если вы хотите использовать эту функцию.',
  allow: 'Разрешить',
  deny: 'Отказать',
  galarmRequiresAccessToContacts:
    'Контакты - это люди, которые могут быть добавлены в качестве участников ваших тревог. Добавить контакты можно следующим образом:\n\n1. Автоматического импорта из контактов телефона. Нажмите "Разрешить доступ" и включите "Контакты".\n\n2. Ручное добавление имени и номера. Нажмите "Добавить контакт", чтобы начать.',
  galarmRequiresAccessToAlarmAndRemindersPermission:
    'Galarm требует разрешения "Будильники и напоминания", чтобы он мог звонить по будильнику точно в указанное время. Включите его на следующем экране.',
  accessToContactsPermissionRequiredAndroid:
    'У Galarm нет разрешения на доступ к контактам вашего телефона.\n\nЕсли вы разрешите доступ, люди из ваших телефонных контактов, использующие Galarm, будут отображаться как контакты Galarm. Этих людей можно добавить в качестве участников тревоги. Нажмите "Разрешить доступ", выберите "Разрешение" и включите "Контакты".\n\nВы по-прежнему можете вручную добавлять контакты в Galarm.',
  accessToContactsPermissionRequiredIos:
    'У Galarm нет разрешения на доступ к контактам вашего телефона.\n\nЕсли вы разрешите доступ, люди из ваших телефонных контактов, использующие Galarm, будут отображаться как контакты Galarm. Этих людей можно добавить в качестве участников тревоги. Нажмите "Разрешить доступ" и включите "Контакты".\n\nВы по-прежнему можете вручную добавлять контакты в Galarm.',
  giveAccess: 'Разрешить доступ',
  enterValidMobileNumber:
    'Для регистрации введите действительный номер телефона.',
  proceedAnyway: 'Приступайте в любом случае',
  checkInvalidPhoneNumber:
    'Мы думаем, что вы ввели неправильный номер {{mobileNumber}}.',
  checkInvalidCountryCode:
    'Неверный код страны, указанный как {{countryCode}}. Если присутствует более одного кода страны, отредактируйте поле, чтобы сохранить применимый код страны.',
  editNumber: 'Номер редактирования',
  editCountryCode: 'Редактировать код страны',
  sendingCodeOnCall: 'Звоню вам с кодом.',
  sendCodeOnCall: 'Позвоните мне с кодом',
  registrationLandingScreenRegisterText:
    'Нажмите Продолжить, чтобы зарегистрироваться по номеру телефона.\n\nЗарегистрировавшись:\n1) Вы сможете добавлять участников в свои будильники и общаться с ними.\n2) Ваши будильники будут сохранены в облаке, и при смене телефона ваши будильники появятся на новом телефоне.',
  continue: 'Продолжить',
  registerLater: 'Пропустить регистрацию',
  cancelRegistration: 'Отмена регистрации',
  welcome: 'Добро пожаловать',
  haventReceivedCodeYet: {
    one: 'Вы еще не получили код? Вы можете запросить код повторно через 1 секунду.',
    other:
      'Вы еще не получили код? Вы можете запросить код еще раз через {{count}} секунд.'
  },
  storagePermissionDenied:
    'Невозможно получить доступ к музыкальным файлам, так как разрешение на хранение запрещено.',
  havingTroubleRegisteringMessage:
    'Galarm не может проверить код после нескольких попыток.\n\nХотите пропустить регистрацию и начать пользоваться приложением?',
  autoDetectVerificationCode:
    'Чтобы упростить регистрацию, Galarm может автоматически определять код проверки, если вы разрешите Galarm просматривать SMS-сообщения.',
  notNow: 'Не сейчас',
  verifyNumberText:
    'Мы отправим SMS с кодом проверки на адрес:\n\n{{formattedMobileNumber}}',
  addToContacts: 'Добавить в контакты',
  todayString: 'Сегодня',
  tomorrowString: 'Завтра',
  backups: 'Резервные копии',
  acintyoTrademark:
    '© 2025 Acintyo, Inc. Все права защищены.\nGalarm является зарегистрированной торговой маркой компании Acintyo, Inc.\nЗащищено патентами США 10382613, 10867286.\nДругие патенты находятся на рассмотрении.',
  acintyoTrademarkWeb:
    '© 2025 Acintyo, Inc. Все права защищены. Galarm является зарегистрированной торговой маркой компании Acintyo, Inc.\nЗащищено патентами США 10382613, 10867286. Другие патенты находятся на рассмотрении.',
  acintyoTrademarkEnterprise: '© 2025 Acintyo, Inc.\nВсе права защищены.',
  markAlarmDone: 'Пометить сигнал тревоги как выполненный',
  skipAlarm: 'Пропускная сигнализация',
  confirmGroupAlarm: 'Подтвердите участие',
  declineGroupAlarm: 'Снижение участия',
  snoozeAlarm: 'Будильник',
  deleteAlarmQuickAction: 'Удалить сигнал тревоги',
  disableAlarm: 'Отключить сигнализацию',
  confirmDisableAlarm: 'Отключить сигнализацию?',
  saveToCalendar: 'Экспорт в календарь',
  stillRingGroupAlarmAfterConfirmingInAdvance:
    'Вы заранее подтверждаете групповой будильник.  Хотите ли вы по-прежнему получать напоминание о времени будильника?',
  updateNow: 'Обновить сейчас',
  nParticipants: {
    one: '1 другой участник',
    other: '{{count}} другие участники'
  },
  details: 'Подробности',
  changeParanthesis: '(Изменить)',
  loadMoreHistory: 'Смотреть подробнее',
  alarmSummaryForHistory:
    'Прошлые ответы для {{alarmName}}.\nПовторяет {{alarmRepetitionString}}\n{{previousOccurrencesString}}',
  alarmSummaryForHistoryWeb: 'Прошлые ответы для {{alarmName}}',
  alarmSummaryForHistoryRepetitionWeb: 'Повторяет {{alarmRepetitionString}}',
  dontSeeCompleteHistory: 'Не видите полной истории?',
  dontSeeCompleteHistoryExplanation:
    'История тревог записывается с момента их создания. Мы сохраняем только ограниченный период истории для каждого сигнала тревоги в зависимости от его повторяемости. Например, если сигнал повторяется каждый день, мы сохраняем историю за 30 дней.\n\nПри изменении времени или повтора сигнала история тревог сбрасывается.',
  noActionAvailableForAlarmOccurrence:
    'Никаких действий для этого случая не предусмотрено.',
  enterEmailIdForFeedback: 'Используется для ответа и обмена обновлениями',
  noPreviousOccurrences: 'Пока нет истории тревог',
  nMissedOccurrencesOfAlarmInLastNDays: {
    zero: 'Пока нет истории тревог',
    one: '{{missedAlarmOccurrences}} пропустил последний {{count}}',
    other: '{{missedAlarmOccurrences}} пропустил последний {{count}}'
  },
  soundAndVibrationSummaryString: {
    zero: '{{volume}}% объема, {{ringtoneName}}',
    one: '{{volume}}% объема, {{ringtoneName}}, Заголовок объявления'
  },
  soundAndVibrationSummaryStringIos: {
    zero: '{{ringtoneName}}',
    one: 'Критический, {{volume}}% объем, {{ringtoneName}}'
  },
  previousOccurrences: 'История тревог',
  retrieving: 'Извлечение...',
  startTimeOfDay: 'Начинается с',
  endTimeOfDay: 'Заканчивается на',
  ringEveryHours: 'Кольца каждый',
  everyNHours: 'Почасовая оплата',
  everyMHoursNMinutes: 'Часы и минуты',
  selectHourlyRepetition: 'Выберите почасовое повторение',
  everyNHoursRepetitionString: {
    one: 'Каждый час с {{startTimeString}} по {{endTimeString}} каждый {{daysString}}',
    other:
      'Каждые {{count}} часов с {{startTimeString}} по {{endTimeString}} каждые {{daysString}}'
  },
  everyNHoursAndMinutesRepetitionString:
    'Каждый {{hoursAndMinutes}} с {{startTimeString}} по {{endTimeString}} каждый {{daysString}}',
  everyMHoursAndNMinutesRepetitionString: 'Каждый {{repeatString}}',
  everyNHoursRepetitionStringForCalendar: {
    one: 'Каждый час с {{startTimeString}} по {{endTimeString}}',
    other: 'Каждые {{count}} часов с {{startTimeString}} по {{endTimeString}}'
  },
  everyNHoursAndMinutesRepetitionStringForCalendar:
    'Каждый {{hoursAndMinutes}} с {{startTimeString}} по {{endTimeString}}',
  everyNHoursAndMinutesRepetitionStringForAlarmSummary:
    'Каждый {{hoursAndMinutes}} до {{endTimeString}}',
  everyNHoursRepetitionStringForAlarmSummary: {
    one: 'Каждый час до {{endTimeString}}',
    other: 'Каждые {{count}} часов до {{endTimeString}}'
  },
  daysRepetitionOddString: {
    other: 'Все нечетные даты',
    one: 'Нечетные даты ({{daysString}})'
  },
  daysRepetitionEvenString: {
    other: 'Все четные даты',
    one: 'Четные даты ({{daysString}})'
  },
  oddNumberedRepetitionPreviewString: {
    one: 'Будильник будет звонить по нечетным числам, выпадающим на {{daysString}}, в указанное время.',
    other: 'Будильник будет звонить во все нечетные даты в указанное время.'
  },
  evenNumberedRepetitionPreviewString: {
    one: 'Будильник будет звонить в четные даты, выпадающие на {{daysString}}, в указанное время.',
    other: 'Будильник будет звонить во все четные даты в указанное время.'
  },
  hourlyRepetitionPreviewString: {
    one: 'Этот будильник будет звонить один раз в {{daysString}}:',
    other: 'Этот будильник будет звонить {{count}} раз каждый {{daysString}} в:'
  },
  daysRepetitionPreviewString: {
    one: 'Этот будильник будет звонить каждый день.',
    other: 'Этот сигнал будет звонить каждые {{count}} дней.'
  },
  weeksRepetitionPreviewString: {
    one: 'Этот будильник будет звонить каждую неделю.',
    other: 'Этот сигнал будет звонить каждые {{count}} недель.'
  },
  everyNDays: { one: 'Каждый день', other: 'Каждые {{count}} дней' },
  everyNWeeks: { one: 'Каждую неделю', other: 'Каждые {{count}} недель' },
  everyNMonths: { one: 'Каждый месяц', other: 'Каждые {{count}} месяцев' },
  everyNYears: { one: 'Каждый год', other: 'Каждые {{count}} лет' },
  cantSetEndTime: 'Невозможно установить время окончания',
  endTimeShouldBeGreater: 'Время окончания должно быть больше времени начала.',
  cantSetStartTime: 'Невозможно установить время начала',
  startTimeShouldBeLess: 'Время начала должно быть меньше времени окончания.',
  everyDaySmall: 'день',
  everyGivenDay: '{{day}}',
  everyGivenDays: '{{days}}',
  adjustingAlarmsAfterTimezoneChange:
    'Мы обнаружили, что вы перешли в другой часовой пояс. Мы корректируем ваши будильники.',
  ringOnDays: 'Кольца на',
  yourAlarmsMayNotRing: 'Ваши будильники могут не звонить',
  yourAlarmsMayNotRingTapToFix:
    'Ваши будильники могут не звонить. Нажмите, чтобы исправить.',
  xiaomiSetupInstructions:
    'Следуйте этим инструкциям, чтобы ваши будильники всегда звонили:\n\n - Нажмите "Включить автозапуск" и разрешите "Galarm", чтобы будильники всегда звонили. \n\nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-mi.',
  oppoSetupInstructions:
    'Следуйте этим инструкциям, чтобы ваши будильники всегда звонили:\n\n - Нажмите "Включить автозапуск" и включите "Разрешить автозапуск".\n\n - Нажмите кнопку "Недавние приложения" на телефоне, проведите пальцем по значку приложения Galarm вниз и нажмите на "Блокировка".  \n\nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-oppo.',
  oppo8AndLowerSetupInstructions:
    'Следуйте этим инструкциям, чтобы ваши будильники всегда звонили:\n\n - Нажмите "Включить автозапуск" и включите "Разрешить автозапуск".\n\n - Нажмите кнопку "Недавние приложения" на телефоне, проведите пальцем по значку приложения Galarm вниз и нажмите на "Блокировка".\n\nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-oppo-8-and-lower.',
  vivo9And10SetupInstructions:
    'Следуйте этим инструкциям, чтобы ваши будильники всегда звонили:\n\n - Нажмите "Включить автозапуск" и разрешите "Galarm".\n\n - Нажмите "Использование батареи", выберите "Высокое фоновое энергопотребление" и разрешите "Galarm".\n\nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-vivo.',
  vivo11SetupInstructions:
    'Следуйте этим инструкциям, чтобы ваши будильники всегда звонили:\n\n- Нажмите "Включить автозапуск" и разрешите "Galarm".\n\n- Нажмите "Использование батареи", выберите "Высокое фоновое энергопотребление" и разрешите "Galarm".\n\nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-vivo-11.',
  vivoSetupInstructions:
    'Следуйте этим инструкциям, чтобы будильники всегда звонили:\n\n- Откройте "Настройки телефона > Приложения > Доступ к специальным приложениям > Автозапуск" и включите автозапуск для Galarm.\n\n- Откройте "Настройки телефона > Аккумулятор > Управление фоновым энергопотреблением > Galarm" и выберите "Не ограничивать фоновое энергопотребление".\n\nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-vivo-12-and-above.',
  vivo8AndLowerSetupInstructions:
    'Следуйте этим инструкциям, чтобы будильники всегда звонили:\n\n - Нажмите "Включить автозапуск" и разрешите "Galarm".\n\n - Нажмите "Использование батареи", выберите "Высокий расход энергии в фоновом режиме" и разрешите "Galarm".\n\nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-vivo-8-and-lower.',
  huawei7AndLowerAdditionalSetupInstructions:
    'Следуйте этим инструкциям, чтобы ваши будильники всегда звонили:\n\n - Нажмите "Защищенные приложения" и разрешите "Galarm".\n\nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-huawei-7-and-lower.',
  huaweiAdditionalSetupInstructions:
    'Следуйте этим инструкциям, чтобы ваши будильники всегда звонили:\n\n - Нажмите "Управление запуском приложений" и отключите "Galarm", чтобы "Управлять вручную". В появившемся окне убедитесь, что включены "Автозапуск" и "Запуск в фоновом режиме".\n\nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-huawei.',
  meizuSetupInstructions:
    'Следуйте инструкциям по ссылке ниже, чтобы ваши будильники всегда звонили: https://dontkillmyapp.com/meizu.',
  asusSetupInstructions:
    'Следуйте этим инструкциям, чтобы ваши будильники всегда звонили:\n\n - Нажмите "Включить автозапуск" и нажмите "Менеджер автозапуска". Включите "Galarm" в "Менеджере автозапуска".\n\nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-asus.',
  nokia8AndLowerAdditionalSetupInstructions:
    'Следуйте этим инструкциям, чтобы ваши будильники всегда звонили:\n\n - Нажмите "Включить автозапуск" и разрешите "Galarm".\n\nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-nokia-8-and-lower.',
  nokiaAdditionalSetupInstructions:
    'Следуйте этим инструкциям, чтобы ваши будильники всегда звонили:\n\n - Нажмите "Ограниченные приложения" и отключите "Galarm".\n\nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-nokia.',
  lenovoSetupInstructions:
    'Следуйте этим инструкциям, чтобы ваши будильники всегда звонили:\n\n - Нажмите кнопку "Недавние приложения" на телефоне, найдите приложение Galarm и нажмите на значок "Блокировка" в правом верхнем углу.\n  \nЧтобы узнать больше, посетите сайт https://dontkillmyapp.com/lenovo.',
  samsungAdditionalSetupInstructions:
    'Следуйте этим инструкциям, чтобы ваши будильники всегда звонили:\n\n - Нажмите "Неконтролируемые приложения" и разрешите "Galarm".\n\nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-samsung.',
  tecnoSetupInstructions:
    'Следуйте инструкциям по ссылке ниже, чтобы ваши будильники всегда звонили: https://www.galarmapp.com/setup-tecno.',
  infinixSetupInstructions:
    'Следуйте инструкциям по ссылке ниже, чтобы ваши будильники всегда звонили: https://www.galarmapp.com/setup-infinix.',
  samsungAdditionalSetupInstructionsAndroid11AndAbove:
    'По умолчанию Samsung показывает "Краткие" уведомления, которые быстро исчезают. Следуйте этим инструкциям, чтобы просмотреть "Подробные" уведомления о тревоге.\n\n - Откройте настройки телефона и выберите "Уведомления".\n - Выберите стиль уведомлений "Подробные"\n  \nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-samsung-android11-and-above.',
  iosSetupInstructions:
    'По умолчанию стиль баннера iOS для уведомлений установлен на "Временный", что приводит к быстрому исчезновению уведомлений. Следуйте этим инструкциям, чтобы установить стиль баннера на "Постоянный".\n\n- Откройте настройки телефона и перейдите в раздел "Галарма".\n- Выберите "Уведомления" и установите для стиля баннера значение "Постоянный".\n\nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-ios.',
  iosSetupInstructions15AndBelow:
    'По умолчанию стиль баннера iOS для уведомлений установлен на "Временный", что приводит к быстрому исчезновению уведомлений. Следуйте этим инструкциям, чтобы установить стиль баннера на "Постоянный".\n\n- Откройте настройки телефона и перейдите в раздел "Галарма".\n- Выберите "Уведомления" и установите для стиля баннера значение "Постоянный".\n\nЧтобы узнать больше, посетите сайт www.galarmapp.com/setup-ios-15-below.',
  setNotificationsStyle: 'Установка стиля уведомлений',
  setNotificationsStyleToDetailed:
    'Установите стиль уведомлений на "Подробный"',
  setBannerStyle: 'Установить стиль баннера',
  setBannerStyleToPersistent: 'Установите стиль баннера на "Постоянный".',
  selectAtleastOneDay: 'Выберите дни, в которые должен звонить этот будильник.',
  selectAtLeastOneHourOrMinute:
    'Либо часы, либо минуты должны быть ненулевым значением',
  hourlyAlarmDefaultStartTimeSetAlert:
    'Время начала сигнала будильника установлено на 8 часов утра.',
  batteryUsage: 'Использование батареи',
  dontShowAgain: 'Больше не показывайся',
  alarmWillRingEveryHourTillSeen:
    'Будильник будет срабатывать каждый час, пока вы не предпримете какие-либо действия.',
  unknown: 'Неизвестный',
  alarmMarkedDone: '{{name}} пометил сигнал тревоги "Выполнено".',
  alarmMarkedSkipped: '{{name}} пропустил сигнал тревоги.',
  alarmIsMarkedDone: '{{alarmName}} отмечен как выполненный.',
  alarmIsSkipped: '{{alarmName}} пропускается.',
  alarmIsConfirmed: '{{alarmName}} подтверждается.',
  alarmIsDeclined: '{{alarmName}} отклоняется.',
  alarmIsSnoozed: '{{alarmName}} засыпает.',
  alarmIsAccepted: '{{alarmName}} принимается.',
  alarmIsRejected: '{{alarmName}} отвергается.',
  newContactInfo:
    'Пожалуйста, укажите имя и номер телефона контактного лица.\n\nВ качестве контактов могут быть добавлены только зарегистрированные пользователи. Если пользователь не является зарегистрированным пользователем Galarm, вы можете пригласить его с помощью "Настройки > Поделиться этим приложением". Вы можете добавить его в качестве контакта после того, как он зарегистрируется, используя его номер телефона. ',
  cantEditContactMobileNumber:
    'Вы не можете редактировать номер телефона. Удалите контакт и добавьте его снова, если хотите изменить номер.',
  phoneContactsNotSyncedPermissionDenied:
    'У Galarm нет разрешения на доступ к телефонным контактам. Телефонные контакты не будут синхронизированы.',
  inviteContactMessage:
    'Привет {{contactName}}, я хочу включить вас в свои будильники и напоминания с помощью Galarm. Загрузите приложение с сайта {{downloadLink}}. Зарегистрируйтесь, используя этот номер, и начните обмениваться будильниками.',
  noRepeat: 'Не повторяется',
  deepLinkNoLongerValidTitle: 'Упс!',
  deepLinkNoLongerValidMessage:
    'Сигнал тревоги не был создан. Это может быть старая или недействительная ссылка.',
  inviteContact: 'Пригласить контакт',
  fromPhoneBook: 'Из адресной книги',
  addFromPhoneBook: 'Приглашение из адресной книги',
  manually: 'Вручную',
  addManualContact: 'Пригласить вручную',
  noOtherContactsFound:
    'Все контакты в вашей адресной книге используют Galarm.',
  cantAddPhoneContactPermissionDenied:
    'У Galarm нет разрешения на доступ к телефонным контактам. Разрешите доступ к контактам.',
  alarmWillRingWithRandomRingtone:
    'Для будильника будет выбрана случайная мелодия.',
  alarmWillRingWithRandomRingtoneGlobal:
    'Для будильников будет выбрана случайная мелодия.',
  createdAlarmFromDeepLinkTitle: 'Все готово!',
  createdAlarmFromDeepLinkMessage:
    'Напоминаем, что на сайте{{alarmName}} вы найдете {{alarmTime}} на {{alarmDate}}',
  createdRepeatingAlarmFromDeepLinkMessage: {
    zero: 'Вам будет напоминать "{{alarmName}}". {{repetitionString}}',
    one: 'Вы будете напоминать о "{{alarmName}}" {{repetitionString}} на {{alarmTime}} начиная. {{alarmDate}}'
  },
  deleteCategoryAlertTitle: 'Удалить категорию?',
  deleteCategoryAlertMessage: {
    zero: '',
    one: 'К этой категории относится 1 сигнал тревоги. Удаление этой категории приведет к сбросу категории для этого сигнала.',
    other:
      '{{count}} тревоги относятся к этой категории. Удаление этой категории приведет к сбросу категории для этих тревог.'
  },
  updateReadyToInstallAlertTitle: 'Установить обновление?',
  updateReadyToInstallAlertMessage:
    'Обновления готовы к установке. Хотите установить обновление прямо сейчас? ',
  hideCategoryAlertTitle: 'Скрыть категорию?',
  hideCategoryAlertMessage: {
    zero: 'В дальнейшем вы не сможете использовать эту категорию.',
    one: 'К этой категории относится 1 сигнал тревоги. Скрытие этой категории приведет к сбросу категории для этого сигнала.\n  \nВы не сможете использовать эту категорию в будущем.',
    other:
      '{{count}} тревоги относятся к этой категории. Скрытие этой категории приведет к сбросу категории для этих тревог.\n  \nВ дальнейшем вы не сможете использовать эту категорию.'
  },
  alarmCategoryDeleteAllAlarmsPrompt: {
    one: 'К этой категории относится 1 сигнализация. Вы хотите удалить его?\n\nОбратите внимание, что тревоги участников не удаляются.',
    other:
      '{{count}} будильников относятся к этой категории. Вы хотите удалить их?\n\nОбратите внимание, что тревоги участников не удаляются.'
  },
  enterNameForGroup: 'Введите имя для группы',
  enterMobileNumber: 'Введите номер телефона',
  enterNotesForAlarm: 'Введите примечания для сигнала тревоги',
  enterUserName: 'Введите свое имя',
  enterEmailId: 'Дополнительно',
  enterFeedback: 'Как мы можем улучшить ситуацию?',
  describeProblem: 'Опишите свою проблему',
  invited: 'Приглашенный',
  resend: 'Повторная отправка',
  addContact: 'Добавить контакт',
  inviteAgain: 'Пригласить снова',
  contactNotRegistered:
    '{{contactName}} еще не установил Galarm. Вы сможете добавить их к сигнализации, как только они установят и зарегистрируются, используя свой номер телефона.',
  registration: 'Регистрация',
  verify: 'Верификация',
  profile: 'Профиль',
  profileImage: 'Изображение профиля',
  addProfileImage: 'Добавить изображение профиля',
  groupDetails: 'Детали группы',
  newGroup: 'Новая группа',
  uploadImage: 'Изменить изображение',
  selectParticipants: 'Выберите участников',
  selectMembers: 'Выберите членов',
  selectTimezone: 'Выберите часовой пояс',
  searchForATimezone: 'Поиск часового пояса',
  timezone: 'Часовой пояс',
  deviceTimezone: 'Часовой пояс устройства',
  specifyTimezoneForAlarm: 'Укажите часовой пояс для сигналов тревоги',
  editName: 'Редактировать имя',
  groupImage: 'Групповое изображение',
  addGroupImage: 'Добавить изображение группы',
  selectAlarmType: 'Создайте сигнал тревоги для',
  contactDetails: 'Контактная информация',
  commonAlarms: 'Сигналы тревоги',
  commonGroups: 'Группы',
  groupAlarmsTitle: 'Сигналы тревоги',
  selectRingtone: 'Выберите мелодию звонка',
  selectMusic: 'Выберите музыку',
  select: 'Выберите',
  personalAlarm: 'Персональная сигнализация',
  groupAlarm: 'Групповая сигнализация',
  newPersonalAlarm: 'Новая персональная сигнализация',
  newGroupAlarm: 'Новая групповая сигнализация',
  editPersonalAlarm: 'Редактирование персонального будильника',
  editGroupAlarm: 'Редактирование группового сигнала тревоги',
  rearrangeParticipants: 'Перестановка участников',
  alarmConversation: 'Чат тревоги',
  deviceRestartRequired: 'Требуется перезапуск приложения',
  disabledAlarm: 'Отключенная сигнализация {{name}}',
  newContact: 'Новый контакт',
  contactName: 'Контактное имя',
  contactMobileNumber: 'Номер контактного телефона',
  enterNameForContact: 'Введите имя контакта',
  pickCountryForContact: 'Страна контакта',
  enterMobileNumberForContact: 'Введите номер телефона контакта',
  specifyNameForContact: 'Имя контакта обязательно',
  specifyValidPhoneNumberForContact: 'Требуется действительный номер телефона',
  addingContact: 'Добавление контакта',
  deletingContact: 'Удаление контакта',
  editingContact: 'Редактирование контактов',
  pending: 'В ожидании',
  deleteContact: 'Удалить контакт',
  galarmContact: 'Добавлено вручную',
  phoneContact: 'Добавлено из контактов телефона',
  confirmDeleteContactTitle: 'Удалить {{name}}?',
  confirmDeleteContact: 'Вы не сможете добавить их в будильники.',
  contactAdded:
    'Отлично! Теперь вы можете добавить {{name}} в качестве участника в свои будильники.',
  contactInvited:
    'На адрес {{name}} было отправлено текстовое сообщение с предложением использовать Galarm.',
  changeSnoozeDuration: 'Продолжительность изменений',
  durationOfEvent: 'Продолжительность мероприятия',
  upgradeToPremium: 'Перейти на премиум',
  premium: 'Премиум',
  alarmLimitReached: 'Достигнут предел тревоги',
  unableToConnectToGooglePlay:
    'Невозможно подключиться к Google Play. Убедитесь, что вы вошли в свою учетную запись Google.',
  cantLoadVideo: 'Невозможно загрузить видео',
  cantUpgradeToPremium: 'Невозможно перейти на премиум',
  unableToConnectToIapAndroid:
    'Невозможно подключиться к Play Store. Пожалуйста, откройте приложение Play Store и убедитесь, что вы вошли в систему.',
  unableToConnectToIapIos:
    'Невозможно подключиться к App Store. Пожалуйста, откройте приложение App Store и убедитесь, что вы вошли в систему.',
  premiumFeaturesIos:
    'В качестве премиум-пользователя вы получаете увеличенный лимит одновременных сигналов {{maxLimit}}.\n\nВаша покупка также помогает нам развивать дополнительные функции.',
  premiumFeaturesAndroid:
    'Создавайте неограниченное количество сигналов тревоги, перейдя на премиум-версию.\n\nВаша покупка также помогает нам развивать дополнительные функции.',
  upgrade: 'Обновление',
  rvInternalError:
    'Мы не смогли загрузить видео из-за внутренней ошибки. Однако мы увеличили лимит тревог на 1.',
  rvNetworkError:
    'Убедитесь, что у вас хорошее интернет-соединение, и попробуйте еще раз.',
  rvNotFoundError:
    'На данный момент мы не смогли найти подходящее видео. Однако мы увеличили лимит тревог на 1.',
  dontRemindMe: 'Не напоминай мне.',
  sameTimeAsBuddy: 'В то же время, что и приятель.',
  noAlertForBuddyAlarm:
    'Вы решили не получать уведомления об этом сигнале тревоги.',
  noAlertRecipientIntervalDescription: 'Вы не будете получать предупреждения.',
  chooseHours: 'Выберите часы',
  chooseMins: 'Выберите минуты',
  changeHours: 'Часы перемен',
  moreOptions: 'Другие варианты...',
  set: 'Установите',
  chooseNumberOfDays: 'Введите количество дней',
  chooseNumberOfWeeks: 'Введите количество недель',
  numberOfDaysShouldBeAtLeastOne: 'Количество дней должно быть не менее 1',
  numberOfWeeksShouldBeAtLeastOne: 'Количество недель должно быть не менее 1',
  numberOfMonthsShouldBeAtLeastOne: 'Количество месяцев должно быть не менее 1',
  numberOfYearsShouldBeAtLeastOne: 'Количество лет должно быть не менее 1',
  frequency: 'Частота',
  configuration: 'Конфигурация',
  endDate: 'Дата окончания сигнала тревоги',
  noEndDate: 'Нет даты окончания',
  alarmEndDateSetOnAlarm:
    'Дата окончания сигнала установлена на {{endDateString}}.',
  noAlarmDateSetForAlarm: 'Для этого сигнала не установлена дата окончания.',
  noOccurrenceForThisAlarmAsPerEndDate:
    'Дата окончания не допускает появления тревоги.',
  alarmDateShouldBeBiggerThanAlarmStartDate:
    'Дата окончания тревоги должна быть после даты начала тревоги.',
  aWeek: 'Неделя',
  aMonth: 'Месяц',
  allInactiveAlarms: 'Все неактивные сигналы тревоги',
  chooseAlarmEndDate: 'Выберите дату окончания сигнала тревоги',
  next: 'Следующий',
  next7Days: 'Через 7 дней после сегодняшнего дня',
  next30Days: '30 дней от сегодняшнего дня',
  next12Months: 'Через 12 месяцев после сегодняшнего дня',
  next10Years: '10 лет спустя',
  chooseDate: 'Выберите дату...',
  learnMore: 'Узнать больше',
  repeatEvery: 'Повторяется каждый',
  repeatEveryDays: 'день(ы)',
  repeatEveryWeeks: 'неделя(ы)',
  repeatEveryMonths: 'месяц(ы)',
  repeatEveryYears: 'год(ы)',
  autoSnooze: 'Автоматическое отключение будильников',
  autoSnoozePerAlarm: 'Автоматическое повторение сигнала будильника',
  unableToUploadGroupAvatar:
    'Невозможно загрузить изображение группы. Пожалуйста, повторите попытку позже',
  addNewMembersToExistingAlarms:
    'У вас есть следующие сигналы тревоги с этой группой:\n\n{{alarmNames}}\n    \nХотите ли вы добавить новых членов в эти тревоги?',
  removeGroupMemberAlert:
    'Удаление участника повлияет на следующие сигналы тревоги:\n\n{{alarmNames}}\n\nВы все еще хотите удалить участника?',
  leaveGroupAlert:
    'Выход из группы повлияет на следующие тревоги:\n\n{{alarmNames}}\n\nВы все еще хотите покинуть группу?',
  updateAppAfterFeedback:
    'Мы заметили, что вы используете старую версию приложения. Пожалуйста, обновите его, чтобы улучшить работу.',
  changesAreLost:
    'У вас есть несохраненные изменения.\n\nХотите ли вы сохранить их перед уходом?',
  recipientAlarmIntervalGreaterThanRepetitionInterval:
    'Интервал между "напоминаниями" должен быть меньше интервала между повторениями.',
  cascadingAlarmIntervalGreaterThanRepetitionInterval:
    'Интервал "Время между оповещениями участников" должен быть меньше интервала повторения.',
  subscriptionCanceled:
    'Ваша премиум-подписка была отменена. Премиум-функции будут недоступны до тех пор, пока вы не возобновите подписку.',
  unableToRenewSubscription:
    'Возникла проблема с продлением вашей премиум-подписки. Пожалуйста, убедитесь, что ваша платежная информация актуальна.',
  notice: 'Уведомление',
  ringerSettingsWillApplyToNewAlarms:
    'Изменения, внесенные в настройки звука и вибрации, будут применяться только к новым будильникам.\n\nДля существующих сигналов тревоги можно отредактировать сигнал, чтобы изменить настройки звука и вибрации.',
  renew: 'Обновить',
  galarmPremium: 'Галарм Премиум',
  payMonthly: 'Платите ежемесячно по адресу {{price}} в месяц',
  payYearly: 'Платите ежегодно по адресу {{price}} в год',
  free: 'Бесплатно',
  unlimited: 'Неограниченное количество',
  personalAlarms: 'Персональные сигнализации',
  groupAlarms: 'Групповые сигналы тревоги',
  buddyAlarms: 'Сигналы тревоги для приятелей',
  alarmRepetitions: 'Повторы',
  ringtones: 'Рингтоны',
  alarmHistory: 'История тревог',
  base: 'Основные',
  advanced: 'Расширенный',
  complete: 'Полный',
  alarmHistoryFree: 'Ограниченный',
  phoneMusicAsRingtone: 'Телефонная музыка в качестве мелодии звонка',
  startFreeTrial: 'Начните 14-дневную бесплатную пробную версию',
  chargedAtEndOfFreeTrial:
    'Плата будет взиматься после окончания 14-дневной бесплатной пробной версии, если вы не отмените подписку.',
  monthlySubscription: 'Ежемесячно',
  yearlySubscription: 'Ежегодно',
  premiumRingtoneRequiresUpgrade:
    'Для этого рингтона требуется подписка Premium.',
  defaultPremiumFeaturesDescription:
    'Перейдите на премиум-версию, чтобы воспользоваться этими замечательными функциями.',
  groupAlarmsPremiumFeaturesDescription:
    'Для создания более 1 групповой сигнализации требуется премиум-подписка.',
  buddyAlarmsPremiumFeaturesDescription:
    'Чтобы создать более одного будильника для другого человека ("приятеля"), необходима премиум-подписка.',
  shareableAlarmLinksPremiumFeaturesDescription:
    'Чтобы создать больше ссылок на сигнализацию, которыми можно делиться, нужна премиум-подписка.',
  alarmCategoryPremiumFeaturesDescription:
    'Для создания новых категорий необходима премиум-подписка.',
  galarmWebPremiumFeaturesDescription:
    'Чтобы использовать Galarm в веб-браузере, необходима премиум-подписка.',
  instantAlarmPremiumFeaturesDescription:
    'Для создания большего количества мгновенных сигналов тревоги требуется премиум-подписка.',
  personalAlarmsFeatureDescription:
    'Используйте личный будильник, чтобы проснуться, принять лекарство или выполнить любое другое задание для себя. При желании можно добавить участников, которые будут оповещены, если вы пропустите будильник, чтобы они могли напомнить вам. Участники также получают уведомление, когда вы отмечаете будильник выполненным.',
  groupAlarmsFeatureDescription:
    'Используйте групповой будильник для групповых мероприятий, таких как выезды, вечеринки или любые другие события. Будильник срабатывает в одно и то же время для всех участников, и они могут подтвердить свое участие.',
  buddyAlarmsFeatureDescription:
    'Создайте будильник для другого человека ("приятеля"), чтобы напомнить ему о делах, которые ему нужно сделать. Вы получите уведомление, чтобы напомнить приятелю, если он пропустит сигнал. Вы также получите уведомление, когда приятель отметит будильник выполненным.',
  alarmRepetitionsFeatureDescription:
    'Создавайте будильники с расширенным количеством повторов, например, каждые 30 минут, каждые 2 часа 45 минут, каждый день, раз в две недели и т. д.',
  ringtonesFeatureDescription:
    'Выбирайте из широкого ассортимента премиальных мелодий для своих будильников. Мы постоянно добавляем новые рингтоны в премиум-вариант.',
  phoneMusicAsRingtoneFeatureDescription:
    'Выберите любую песню/музыку на вашем телефоне в качестве мелодии будильника.',
  shareableAlarmLinksFeatureDescription:
    'Вы можете поделиться тревожными сигналами с другими людьми, используя ссылку.\n\nНапример, учитель может поделиться ссылкой на будильник своего класса с учениками, используя электронную почту, WhatsApp или любое приложение для обмена сообщениями. Когда ученики нажмут на ссылку, на их телефонах будет создана копия классного будильника. В указанное время все ученики получат уведомление о необходимости присоединиться к классу.',
  instantAlarmFeatureDescription:
    'Мгновенное оповещение группы людей одним нажатием кнопки.\n\nИспользуйте этот сигнал, чтобы предупредить их об экстренной тренировке, начале игры, срочном задании/совещании и других подобных событиях, требующих немедленного внимания.',
  alarmHistoryFeatureDescription:
    'Просматривайте все прошлые ответы для каждого повторяющегося сигнала. Это позволит вам легко узнать, когда вы пропустили урок физкультуры, когда ваша мама пропустила прием лекарств и т. д.',
  announceAlarmTitleFeatureDescription:
    'Объявление названия сигнала тревоги при звонке будильника.',
  exportToCalendarPremiumFeaturesDescription:
    'Чтобы экспортировать больше будильников в календарь, нужна премиум-подписка.',
  exportToCalendarFeatureDescription:
    'Вы можете экспортировать будильники в календарь. Это позволит вам легко просматривать будильники в календаре устройства и лучше отражать вашу доступность.',
  galarmWebFeatureDescription:
    'Используйте Galarm в веб-браузере для создания, редактирования и удаления сигналов тревоги.',
  preReminderFeatureDescription:
    'Установите предварительные напоминания, чтобы получать уведомления о предстоящих будильниках. Вы можете настроить относительную продолжительность оповещения до фактического времени срабатывания будильника, например за 30 минут, за 1 день и т. д.',
  calendarViewFeatureDescription:
    'Просмотр будильников в календаре позволяет легко увидеть будильники на любой день.',
  updatePhoneNumberFeatureDescription:
    'Вы можете изменить номер телефона, используемый для этой учетной записи. Все ваши будильники, контакты, группы и другие настройки будут перенесены на новый номер телефона.',
  alarmPhotoFeatureDescription:
    'Добавьте фотографию к будильнику, чтобы быстро получить визуальные подсказки, например фотографию лекарства, инструкции по выполнению задания, предмета и т. д. Фотография будет отображаться при звонке будильника.',
  taskListFeatureDescription:
    'Создавайте списки задач, чтобы держать связанные задачи вместе.',
  calendarViewPremiumFeature: 'Просмотр календаря',
  updatePhoneNumberPremiumFeature: 'Изменить номер телефона',
  alarmNotFound: 'Сигнал тревоги не найден',
  alarmNotFoundMessage:
    'Возможно, этот сигнал был недавно удален. Нажмите "Удалить", чтобы отключить дальнейшие уведомления для этого сигнала.',
  alarmExistsWithDeepLinkTitle: 'Дублирующая сигнализация',
  alarmExistsWithDeepLinkMessage:
    'Будильник, созданный по этой ссылке, уже существует на вашем телефоне.',
  alarmDoesntHaveNextDate: 'У тревоги нет действительной следующей даты.',
  sharePersonalAlarmDeepLinkDescription:
    'Нажмите на эту ссылку, чтобы создать сигнал тревоги для этого события на сайте {{dateString}}.',
  joinGroupAlarmDeepLinkDescription:
    'Нажмите на эту ссылку, чтобы присоединиться к этому групповому мероприятию на {{dateString}}',
  subscribedAlarmEdited:
    '{{alarmCreatorName}} обновился {{alarmName}}. Хотите обновить свою сигнализацию?',
  subscribedAlarmDeleted:
    '{{alarmCreatorName}} удалил {{alarmName}}. Вы хотите удалить свой будильник?',
  responseReceivedForTicket:
    'Мы ответили на ваш билет #{{ticketId}} по адресу: {{email}}. Если его нет в папке "Входящие", проверьте папки спама на наличие письма от support@galarm.zendesk.com.',
  newTicketReceived:
    'Спасибо, что написали нам. Мы создали тикет #{{ticketId}} для отслеживания вашего запроса.\n\nМы ответим на указанный вами адрес электронной почты: {{email}}. Если он не верен, пожалуйста, отправьте свой отзыв еще раз, указав правильный адрес электронной почты.\n\nПожалуйста, добавьте support@galarm.zendesk.com в адресную книгу электронной почты, чтобы обеспечить правильную доставку наших ответов. Мы также отправим сюда уведомление о том, что ответили на ваш запрос.',
  sentAccountBackup:
    'Мы отправили данные о вашей сигнализации на {{email}}. Если их нет в папке "Входящие", проверьте папки со спамом на наличие письма от noreply@acintyo.com.',
  alarmDoesntExist: 'Тревоги не существует.',
  shareLink: 'Поделиться ссылкой',
  joinedGroupAlarmFromDeepLinkMessage:
    'Напоминаем, что на сайте{{alarmName}} вы найдете {{alarmTime}} на {{alarmDate}}',
  joinedRepeatingGroupAlarmFromDeepLinkMessage: {
    zero: 'Вам будет напоминать "{{alarmName}}". {{repetitionString}}',
    one: 'Вы будете напоминать о "{{alarmName}}" {{repetitionString}} на {{alarmTime}} начиная. {{alarmDate}}'
  },
  youHaveSubscribedToThisAlarm:
    'Вы следите за этим сигналом тревоги с сайта {{creatorName}}.',
  alreadySharedAlarmDescription: {
    zero: 'У вас нет последователей для этой тревоги.\n\nВы можете продолжить делиться этим сигналом с другими людьми, используя ссылку. Когда они нажмут на ссылку, на их телефоне будет создана копия этого будильника.',
    one: '{{count}} человек следит за этой тревогой.\n\nВы можете продолжить делиться этим сигналом с другими людьми, используя ссылку. Когда они нажмут на ссылку, на их телефоне будет создана копия этого сигнала.',
    other:
      '{{count}} люди следят за этим сигналом тревоги.\n\nВы можете продолжить делиться этим сигналом с другими людьми, используя ссылку. Когда они нажмут на ссылку, на их телефоне будет создана копия этого сигнала.'
  },
  shareParentAlarmDescription:
    'Вы следите за этим сигналом тревоги с сайта {{creatorName}}.\n\nВы также можете поделиться этим сигналом с другими людьми, используя ссылку. Когда они нажмут на ссылку, на их телефоне будет создана копия этого сигнала, и они также смогут следить за ним.',
  shareableAlarmLinks: 'Делимые ссылки',
  nPeopleFollowingAlarm: {
    zero: 'У вас нет последователей для этой тревоги.',
    one: '{{count}} человек следит за этой тревогой.',
    other: '{{count}} люди следят за этим сигналом тревоги.'
  },
  likeUsOnFacebook: 'Facebook',
  followUsOnTwitter: 'Twitter',
  followUsOnInstagram: 'Instagram',
  youtube: 'YouTube',
  mediumBlog: 'Блоги на Medium',
  howtoVideos: 'Видеоролики',
  followGalarmOnSocialMedia: 'Следите за Galarm в социальных сетях',
  galarmOnSocialMedia: 'Galarm в социальных сетях',
  followGalarmOnSocialMediaDescription:
    'Ознакомьтесь с новостями об обновлениях приложения, использовании функций, предстоящих функциях, а также с обзорами ключевых приложений. Там же можно пообщаться с командой Galarm.',
  sharedAlarm: 'Редактировать общий сигнал тревоги',
  editingPublishedAlarm: {
    one: 'Вы редактируете сигнал тревоги, которым вы поделились ранее с помощью ссылки. {{count}} человек в настоящее время следит за этим сигналом.\n\nКогда вы внесете какие-либо изменения в этот сигнал, он получит уведомление об изменениях.',
    other:
      'Вы редактируете сигнал тревоги, которым вы поделились ранее, используя ссылку. {{count}} человек в настоящее время следят за этим сигналом.\n\nКогда вы внесете какие-либо изменения в этот сигнал, они будут уведомлены об изменениях.'
  },
  editingSubscribedAlarm:
    'Вы следите за этой тревогой с сайта {{creatorName}}. После редактирования вы не будете получать обновлений для этой тревоги.',
  viewAlarm: 'Просмотр сигнализации',
  view: 'Посмотреть',
  editAlarm: 'Редактировать сигнал тревоги',
  thanksForTryingPremiumTitle: 'Все готово!',
  thanksForTryingPremiumMessage:
    'Мы надеемся, что вам понравятся премиум-функции.\n\nПри возникновении вопросов обращайтесь в службу поддержки через "Настройки > Обратная связь" или пишите нам на galarm@acintyo.com.',
  subscribedAlarmEditedInAlarmDetails:
    '{{creatorName}} сменил сигнализацию.\nОбновить сигнализацию?',
  subscribedAlarmDeletedInAlarmDetails:
    '{{creatorName}} удалил свой будильник.\nУдалить свой будильник?',
  updateSubscribedAlarm: 'Да, обновление',
  deleteSubscribedAlarm: 'Да, удалить',
  ignoreSubscribedAlarm: 'Нет, не обращайте внимания',
  customRepetitionPremiumScreenDescription:
    'Пользовательские повторы - это премиум-функция.\n\nС помощью этой функции можно создавать сигналы тревоги с расширенными повторами. Примеры включают:\n',
  repeatAlternateDate: '✅ Повторяйте в разные дни',
  repeatEveryNDay: '✅ Повторять каждые 3 дня',
  repeatEveryNHoursAndMMinutes: '✅ Повторять каждые 2 часа 30 минут',
  repeatEveryNMinutes: '✅ Повторяйте каждые 45 минут',
  repeatBiweekly: '✅ Повторять каждые 2 недели',
  repeatEveryNWeeks: '✅ Повторять каждые 6 недель',
  repeatEveryNMonths: '✅ Повторяйте каждые 3 месяца (ежеквартально)',
  repeatEveryLastDayOfMonth: '✅ Повторяйте последний день каждого месяца',
  repeatDayOfWeekOfMonth: '✅ Повтор во 2-ю субботу каждого месяца',
  repeatLastDayOfWeekOfMonth: '✅ Повтор в последнюю пятницу каждого месяца',
  customRepetition: 'Пользовательское повторение',
  lastDayOfMonth: 'Последний день каждого месяца',
  dayOfWeekInMonth: '{{weekNumberOfDayInMonth}} {{dayName}} каждого месяца',
  lastDayOfWeekInMonth: 'Последний {{dayName}} каждого месяца',
  dayOfWeekInMonthInYearSummary:
    '{{weekNumberOfDayInMonth}} {{dayName}} из {{monthName}}',
  lastDayOfWeekInMonthInYearSummary: 'Последний {{dayName}} из {{monthName}}',
  lastDayOfMonthInYearSummary: 'Последний день {{monthName}}',
  dayOfWeekInMonthInYear:
    '{{weekNumberOfDayInMonth}} {{dayName}} {{monthName}} каждый год',
  lastDayOfWeekInMonthInYear:
    'Последний {{dayName}} из {{monthName}} каждый год',
  lastDayOfMonthInYear: 'Последний день {{monthName}} каждый год',
  chooseAMonthsConfiguration: 'Пожалуйста, выберите конфигурацию.',
  chooseADaysConfiguration: 'Пожалуйста, выберите конфигурацию',
  chooseAYearsConfiguration: 'Пожалуйста, выберите конфигурацию.',
  didntGetCodeNewUser:
    'Не получили код?\n\nВы можете запросить код еще раз или пока пропустить регистрацию. Вы можете зарегистрироваться позже.',
  didntGetCodeExistingUser:
    'Не получили код?\n\nВы можете запросить код еще раз или отменить регистрацию. Вы можете зарегистрироваться позже.',
  didntGetCodeUpdatePhoneNumber:
    'Не получили код?\n\nВы можете запросить код еще раз или повторить попытку позже.',
  alreadySentCodeAgain:
    'Мы повторно отправили вам код. Если у вас возникли трудности с получением кода, пожалуйста, пока пропустите регистрацию и зарегистрируйтесь позже.',
  theme: 'Тема',
  announceAlarmName: 'Объявить название сигнала тревоги',
  ttsHelperText:
    'Название будильника будет объявлено во время звонка. Чтобы прослушать предварительный просмотр, можно нажать кнопку воспроизведения перед названием будильника.',
  initializingTts: 'Инициализация преобразования текста в речь',
  errorSpeakingAlarmName:
    'Невозможно произнести название будильника. Обратитесь в службу поддержки из раздела "Настройки > Обратная связь".',
  entityAlarm: 'сигнализация',
  entityGroup: 'группа',
  entityContact: 'связаться с',
  admin: 'Администратор',
  specifyAlarmTitleToSpeak:
    'Укажите название сигнала тревоги, который нужно произнести',
  wakeup: 'Проснись',
  ttsPremiumScreenDescription:
    'Объявление названия будильника - это премиум-функция.\n\nЕсли эта функция включена, название будильника будет объявляться при звонке будильника.\n\nДля предварительного просмотра укажите название будильника и нажмите кнопку воспроизведения.',
  unknownAlarmCategory: 'Неизвестная категория сигнализации',
  cantAnnounceAlarmTitle: 'Название сигнализации не будет объявлено',
  ringtoneDurationIsSmall:
    'Продолжительность мелодии должна составлять не менее 5 секунд, чтобы название будильника было озвучено.\n\nХотите ли вы продолжить работу с этими настройками?',
  noActionItems: 'Никаких действий.',
  personNotInContacts: 'Этого человека нет в ваших контактах в Galarm.',
  light: 'Свет',
  dark: 'Темнота',
  systemDefault: 'Использование настроек устройства',
  chooseTheme: 'Выберите тему',
  dontSeeAllYourContacts: 'Не видите всех своих контактов?',
  lastContactsSyncedAt: 'Последняя синхронизация в {{dateString}}',
  refresh: 'Обновить',
  forever: 'Навсегда',
  autoSnoozeConfiguration: 'Настройте функцию Snooze',
  autoSnoozeConfigurationSummary:
    '{{autoSnoozeDurationLabel}}, {{autoSnoozeCountLabel}}',
  uncategorizedCategoryName: 'Не классифицировано',
  uncategorizedCategoryScreenTitle: 'Без категории',
  setAlarmCategory: 'Установка категории сигнала тревоги',
  changeAlarmCategory: 'Изменить категорию сигнализации',
  viewAlarmHistory: 'Просмотр истории тревог',
  computingAlarmHistory: 'Вычислительная сводка для истории тревог...',
  alarmByCategories: '{{name}} Сигналы тревоги',
  alarmCategories: 'Категории',
  editAlarmCategory: 'Редактировать категорию',
  deleteAlarmCategory: 'Удалить категорию',
  newAlarmCategoryTitle: 'Новая категория',
  newAlarmCategoryNamePlaceholder: 'Укажите имя',
  editAlarmCategoryTitle: 'Редактировать категорию',
  alarmCategorySummary: {
    zero: '{{alarmsSummary}}',
    one: '{{alarmsSummary}}, {{count}} пропущено',
    other: '{{alarmsSummary}}, {{count}} пропущено'
  },
  numAlarms: {
    zero: 'Никаких тревог',
    one: '{{count}} сигнализация',
    other: '{{count}} сигнализация'
  },
  numIncidents: {
    zero: 'Без происшествий',
    one: '{{count}} инцидент',
    other: '{{count}} происшествия'
  },
  openedIncidents: 'Открытые инциденты',
  closedIncidents: 'Закрытые инциденты',
  incidentChart: 'Диаграмма происшествий (за последние 30 дней)',
  incidentCalendar: 'Календарь происшествий',
  incidentDistribution: 'Распределение инцидентов (за последние 30 дней)',
  noIncidentsOpenedClosedInLast30Days:
    'За последние 30 дней не было открыто или закрыто ни одного инцидента',
  noIncidentsOpenedInLast30Days:
    'Отсутствие инцидентов, открытых за последние 30 дней',
  color: 'Цвет',
  createNewAlarmCategory:
    'Создайте новую категорию, нажав на кнопку + в правом нижнем углу.',
  setValidName: 'Установите правильное имя',
  specifyTimezoneForAlarmMessage:
    'При создании сигналов тревоги можно указать часовой пояс. Сигналы тревоги будут звонить в соответствии с указанным часовым поясом. \n\nЕсли выбрать "Часовой пояс устройства", будильники будут звонить в соответствии с часовым поясом вашего устройства.',
  alarmCategoryFeatureDescription:
    'Создавайте собственные категории для будильников. Категории позволяют легко упорядочить сигналы тревоги.',
  markAlarmDoneInAdvance: 'Отметить тревогу "Сделано" раньше времени?',
  skipAlarmInAdvance: '"Пропустить" будильник раньше времени?',
  markAlarmDoneInAdvanceMessageRepeatingAlarm:
    'Будильник не зазвонит на сайте {{dateTimeString}}, если вы отметите его "Готово" сейчас.',
  skipAlarmInAdvanceMessageRepeatingAlarm:
    'Будильник не зазвонит на сайте {{dateTimeString}}, если вы пропустите его сейчас.',
  markAlarmDoneInAdvanceMessageOneTimeAlarm:
    'Будильник не зазвонит на сайте {{dateTimeString}}, если вы отметите его "Готово" сейчас.',
  skipAlarmInAdvanceMessageOneTimeAlarm:
    'Будильник не зазвонит на сайте {{dateTimeString}}, если вы пропустите его сейчас.',
  alarmsByCategories: 'Сигналы тревоги по категориям',
  workAlarmCategory: 'Работа',
  homeAlarmCategory: 'Главная',
  birthdaysAlarmCategory: 'Дни рождения',
  more: 'Подробнее',
  alarmCategory: 'Категория сигнализации',
  editAlarmCategoryColor: 'Редактировать цвет',
  editAlarmCategoryColorTitle: 'Редактировать цвет для {{name}}',
  allUserCategoriesDeleted:
    'Все созданные вами категории тревог были удалены, поскольку премиум-подписка была отменена. Сигналы тревоги в этих категориях будут отображаться в разделе "Не категоризированы".',
  calendar: 'Календарь',
  eventExportedFromGalarm:
    '"Экспортировано из Галарм на {{dateString}} по адресу {{timeString}}."',
  unableToExportEventToCalendar:
    'Невозможно экспортировать событие в календарь. Убедитесь, что вы дали разрешение на доступ к календарю на устройстве. Если проблема сохраняется, отправьте нам отзыв через "Настройки > Обратная связь".',
  scanQrCode:
    'Чтобы получить доступ к Galarm через браузер, перейдите на сайт web.galarm.app и отсканируйте QR-код.',
  logOut: 'Выйти из системы',
  useHere: 'Используйте здесь',
  appRunningElsewhere:
    'Вы вышли из этой сессии. Хотите возобновить эту сессию?',
  dateTime: 'Дата и время',
  selectAtLeastOneDayForRepetition:
    'Выберите хотя бы один день, в который будильник должен повторяться.',
  chooseNumberOfDaysForAlarmRepetition:
    'Введите количество дней, по истечении которых сигнал тревоги должен повторяться.',
  chooseNumberOfWeeksForAlarmRepetition:
    'Введите количество недель, по истечении которых сигнал тревоги должен повторяться.',
  chooseNumberOfMonthsForAlarmRepetition:
    'Введите количество месяцев, по истечении которых сигнал тревоги должен повторяться.',
  chooseNumberOfYearsForAlarmRepetition:
    'Введите количество лет, по истечении которых сигнал тревоги должен повторяться.',
  previouslySelectedContactsAreUnselected:
    'Ранее выбранный контакт(ы) снимается(ются).',
  previouslySelectedGroupIsUnselected:
    'Ранее выбранная группа снимается с выбора.',
  galarmWebInstructions:
    '1. Откройте приложение Galarm на своем телефоне\n2. Перейдите на вкладку "Настройки" и нажмите на "Galarm Web".\n3. Убедитесь, что у вас установлена последняя версия приложения, если вы не видите эту опцию.\n4. Отсканируйте QR-код справа',
  likeToCreateAlarm: 'Создайте сигнал тревоги для...',
  payUtilityBills: 'Оплатить счета',
  wakeupAlarmName: 'Проснись',
  exerciseAlarmName: 'Упражнение',
  drinkWaterAlarmName: 'Пейте воду',
  everyNHoursRepetitionStringShortSummary: {
    one: '{{startTimeString}} на {{endTimeString}} Каждый час',
    other: '{{startTimeString}} на {{endTimeString}} Каждые {{count}} часов'
  },
  firstTimeManagementQuote:
    '"Плохая новость - время летит. Хорошая новость - вы пилот".',
  firstTimeManagementQuoteAuthor: 'Майкл Альтшулер',
  secondTimeManagementQuote:
    '"Все управление временем начинается с планирования".',
  secondTimeManagementQuoteAuthor: 'Том Грининг',
  thirdTimeManagementQuote:
    '"Никогда не оставляйте на завтра то, что можете сделать сегодня".',
  thirdTimeManagementQuoteAuthor: 'Бенджамин Франклин',
  fourthTimeManagementQuote:
    '"Время - это то, чего мы хотим больше всего, но чем мы хуже всего пользуемся".',
  fourthTimeManagementQuoteAuthor: 'Уильям Пенн',
  fifthTimeManagementQuote:
    '"Через год вы, возможно, пожалеете, что не начали сегодня".',
  fifthTimeManagementQuoteAuthor: 'Карен Лэмб',
  sixthTimeManagementQuote: '"Вы можете медлить, но время не будет медлить".',
  sixthTimeManagementQuoteAuthor: 'Бенджамин Франклин',
  tapToGetStarted: 'Нажмите "+", чтобы начать работу.',
  allCategories: 'Все категории',
  createAlarmWithContact: 'Создайте сигнал тревоги с помощью {{name}}',
  createAlarmWithGroup: 'Создайте сигнал тревоги с помощью {{name}}',
  editGroup: 'Группа редактирования',
  discardChanges: 'Текущие изменения будут отменены. Продолжить?',
  alarmWillRingEveryNDays: {
    zero: 'Будильник будет звонить каждый день.',
    one: 'Будильник будет звонить в разные дни.',
    other: 'Будильник будет звонить каждый {{dayWithOrdinal}} день.'
  },
  hoursString: { zero: '', one: '1 час', other: '{{count}} часы' },
  minutesString: { zero: '', one: '1 минута', other: '{{count}} минут' },
  alarmWillRingEveryMHoursAndNMinutes:
    'Будильник будет звонить после каждого {{repeatString}}, начиная с {{dayString}}. После этого {{otherDaysString}} и так далее.',
  alarmWillRingEveryNWeeks: {
    zero: 'Будильник будет звонить каждую неделю.',
    one: 'Будильник будет звонить раз в две недели.',
    other: 'Будильник будет звонить каждую {{weekWithOrdinal}} неделю.'
  },
  alarmWillRingEveryNMonths: {
    zero: 'Будильник будет звонить каждый месяц.',
    one: 'Будильник будет звонить раз в два месяца.',
    other: 'Сигнал тревоги будет звонить каждый {{monthWithOrdinal}} месяц.'
  },
  alarmWillRingEveryNYears: {
    zero: 'Будильник будет звонить каждый год.',
    one: 'Будильник будет звонить раз в два года.',
    other: 'Сигнал тревоги будет звучать каждый {{yearWithOrdinal}} год.'
  },
  ringParticipantAlarmsByDefaultTooltipMessage:
    'Если эта опция включена, сигналы тревоги от других людей будут звонить без принятия. Вы все равно должны принять сигнал, чтобы сообщить его создателю о своем намерении принять участие в тревоге.\n\nЕсли эта опция отключена, будильники, добавленные для вас другими пользователями, не будут звонить на ваш телефон, пока вы их явно не примете.',
  specifyTimezoneForAlarmDefaultTooltipMessage:
    'Если этот параметр включен, вы можете указать часовой пояс при создании сигналов тревоги. Сигналы тревоги будут звонить в соответствии с указанным часовым поясом.\n\nЕсли этот параметр отключен, сигналы будут звонить в соответствии с часовым поясом вашего устройства.',
  ringOnEarphoneOnlyTooltipTitle:
    'Поведение сигнализации при подключении наушников',
  ringOnEarphoneOnlyTooltipMessage:
    'При подключении наушников вы можете настроить будильники так, чтобы они звонили только на наушники или на динамик телефона и на наушники.\n\nЕсли наушники не подключены, сигналы тревоги будут звучать в динамике телефона.',
  gestureOptionsTooltipTitle: 'Жест для отключения сигнала тревоги',
  gestureOptionsTooltipMessage:
    'Когда будильник звонит на экране блокировки, вы можете отключить его, нажав или сдвинув кнопку.\n\nЭта настройка позволяет выбрать способ отключения будильника.',
  notificationSettingsTooltipTitle: 'Настройки уведомлений',
  notificationSettingsTooltipMessage:
    'Включите уведомления, которые вы хотите получать, и отключите те, о которых вы не хотите получать уведомления.',
  messagesForAlarm: 'Сообщения для {{name}}',
  systemNotificationsTooltipMessage:
    'Уведомления, генерируемые приложением для таких событий, как:\n  - при смене часового пояса у контакта\n  - когда приглашенный контакт регистрируется на Galarm\n  - когда тревоги происходят из-за того, что кто-то удаляет свою учетную запись',
  galarmWebNotificationsTooltipMessage:
    'Уведомления, отправленные вам от Galarm Web.',
  alarmsfromOthersNotificationsTooltipMessage:
    'Уведомления, которые отправляются, когда вы добавляетесь в тревогу в качестве участника.',
  alarmChatNotifictionsTooltipMessage:
    'Отправка уведомлений о сообщениях чата в будильнике.',
  groupNotificationsTooltipMessage:
    'Уведомления, которые отправляются, когда вас добавляют в группу, удаляют из нее или добавляют/удаляют из нее кого-то другого.',
  alarmAcknowledgementNotificationsTooltipMessage:
    'Уведомления, отправляемые, когда участник подтверждает сигнал тревоги, в котором вы также являетесь участником.',
  sharedAlarmNotificationsTooltipMessage:
    'Уведомления, которые отправляются:\n  - когда кто-то подписывается на сигнал тревоги, которым вы поделились по ссылке\n  - когда сигнал тревоги, на который вы подписались, был изменен',
  sleepTimer: 'Музыка для сна',
  sleepTimerTitle: 'Воспроизведение музыки для',
  ongoingSleepTimer: 'Музыка для сна в режиме реального времени',
  stopSleepTimer: 'Вы хотите остановить текущую музыку?',
  restartSleepTimer: 'Вы хотите остановить текущую музыку и начать новую?',
  play: 'Играть',
  youAreOffline:
    'В настоящее время вы находитесь в автономном режиме. Чтобы выполнить какие-либо операции, перейдите в режим онлайн.',
  sleepMusicTooltip:
    'Воспроизводите естественные звуки, чтобы расслабить тело и разум. Музыка прекращает воспроизведение по истечении указанного времени.',
  alarmLinkCopiedToClipboard:
    'Ссылка на сигнал тревоги копируется в буфер обмена.',
  confirmLogOut: 'Вы хотите выйти из системы?',
  appNotRunningMessage:
    'Мы обнаружили, что Galarm не запущен на вашем телефоне. Нажмите, чтобы запустить Galarm, и вы не пропустите ни одного важного сигнала.',
  tapToEnterNotesForAlarm: 'Нажмите, чтобы ввести заметки',
  accountAlreadyExists: 'Существующая учетная запись найдена',
  accountsMerged:
    'Мы обнаружили существующий счет, связанный с этим номером мобильного телефона. Мы объединили эти два счета.',
  upgradeToPremiumToAssignUserDefinedCategory:
    'Чтобы выбрать категорию, определяемую пользователем, перейдите на версию Premium.',
  userDefinedCategoryNotSetForAlarm:
    'Обновите версию до Premium, чтобы автоматически назначать определенные пользователем категории. Категория не задана для сигнала тревоги.',
  alarmDetails: 'Детали сигнализации',
  profileDetails: 'Профиль',
  activeWebSession:
    'У вас уже есть активная веб-сессия. Вы можете выйти из него или начать новый сеанс.\n\nПри запуске новой сессии вы автоматически выйдете из активной веб-сессии.',
  startNewSession: 'Начать новый сеанс',
  confirmWebSessionLogout:
    'Это приведет к выходу из текущей веб-сессии. Вы можете начать новый сеанс, просканировав код еще раз.',
  defaultInstantAlarmTitleForGroup: '{{groupName}} Тревога от {{creatorName}}',
  defaultInstantAlarmTitleForContact: 'Тревога от {{creatorName}}',
  atleastOneMemberShouldBeActive: 'Хотя бы один участник должен быть активным.',
  activeParticipants: 'Активные участники',
  acceptAlarm: 'Принять сигнал тревоги',
  rejectAlarm: 'Отклонить сигнал тревоги',
  nConfirmed: '{{count}} подтверждено',
  nDeclined: '{{count}} отказался',
  nPending: '{{count}} в ожидании',
  everyoneConfirmed: 'Все подтвердили.',
  everyoneDeclined: 'Все отказались',
  appTagline: 'Никогда ничего не пропустите',
  usePreviousBackup: 'Я зарегистрированный пользователь >',
  viewAlarmsByCategories: 'Просмотр сигналов тревоги по категориям',
  viewAllAlarms: 'Посмотреть все сигнализации',
  switchToSummaryView: 'Переключитесь на режим просмотра сводок',
  switchToListView: 'Переключение в режим просмотра списка',
  hideHourlyAlarms: 'Скрыть часовые сигналы тревоги',
  calendarView: 'Календарь Галарм',
  viewRecentlyDeletedAlarms: 'Просмотр недавно удаленных сигналов тревоги',
  deletedOnDate: 'Удалено на {{alarmDate}}',
  recentlyDeletedAlarmFooterText:
    'Этот сигнал тревоги был удален на {{alarmDate}}',
  noRecentlyDeletedAlarms: 'Отсутствие недавно удаленных сигналов тревоги',
  restoreAlarmsFromMobileApp:
    'Эти сигналы будут автоматически удалены через 30 дней после их удаления. Если вы хотите восстановить любой из них, перейдите на экран "Недавно удаленные будильники" в мобильном приложении и нажмите на значок восстановления.',
  deleteInactiveAlarms: 'Удаление неактивных сигналов тревоги',
  defaultConfigurationUpdated: 'Конфигурация по умолчанию была обновлена.',
  notAlerted: '(исключено)',
  alarmKeepsRingingHelp: 'Помогите! Мой будильник продолжает звонить',
  alarmKeepsRingingHelpMessage:
    'Мы обновили ваши сигналы тревоги и отправили отчет о проблеме.',
  alarmKeepsRingingHelpAlert:
    'Мы обновим ваши сигналы тревоги, и вы больше не будете наблюдать эту проблему. Мы также отправим отчет о проблеме в нашу службу поддержки для дальнейшего расследования.\n\n  Если проблема сохраняется, свяжитесь с нами через "Настройки > Обратная связь".',
  sendingFeedback: 'Отправка отзывов',
  sendingProblemReport: 'Отправка сообщения о проблеме',
  fixingAlarms: 'Обновление сигналов тревоги',
  existingAccountFound: 'Восстановленная резервная копия',
  existingAccountDataRestored: {
    zero: 'Поздравляем, все данные были восстановлены из резервной копии.',
    one: 'Поздравляем, все данные были восстановлены из резервной копии.',
    other: 'Поздравляем, все данные были восстановлены из резервной копии.'
  },
  noExistingAccountFound: 'Резервная копия не найдена',
  createdNewAccount:
    'Этот номер телефона не был зарегистрирован в Galarm. Мы создали новый аккаунт, используя этот номер телефона.',
  iosCloseToAllowedNumNotificationsScheduled: {
    zero: 'iOS позволяет приложению планировать до 64 уведомлений. Вы использовали все эти уведомления. Не исключено, что вы можете пропустить несколько будильников.',
    one: 'iOS позволяет приложению планировать до 64 уведомлений. Вы использовали {{numNotifications}} из этих уведомлений.'
  },
  acknowledgeAlarmToScheduleNextOccurrence:
    'Это последнее уведомление для данного сигнала тревоги. Нажмите на это уведомление и выполните действие, чтобы запланировать следующее появление этого сигнала.',
  lastNotificationForOneTimeAlarm:
    'Это последнее уведомление для данного сигнала тревоги.',
  criticalAlertsMessageTitle: 'Звонок будильника при выключенном телефоне',
  criticalAlertsMessageDescription:
    '\nВы можете настроить Galarm на использование iOS Critical Alerts для подачи сигнала тревоги, когда ваш телефон отключен. Хотите включить эту функцию для всех будильников?\n\nВы также можете выборочно включить эту функцию для некоторых будильников, отредактировав их настройки "Звук и вибрация > Критические оповещения".',
  allowCriticalAlerts: 'Разрешить критические оповещения',
  criticalAlertsPermissionDenied:
    'Для отображения критических оповещений Galarm требуется разрешение вашего телефона. Пожалуйста, включите это разрешение в настройках телефона.',
  enableCriticalAlertsForAllAlarms: 'Да, включить для всех сигналов тревоги',
  selectivelyEnableCriticalAlerts: 'Нет, я буду включать выборочно.',
  firstName: 'Имя',
  lastName: 'Фамилия',
  email: 'Электронная почта',
  password: 'Пароль',
  confirmPassword: 'Подтвердите пароль',
  signup: 'Зарегистрироваться',
  login: 'Вход в систему',
  alreadySignedUp: 'Уже подписались?',
  notAUser: 'Не являетесь пользователем?',
  subscribe: 'Подписаться',
  choosePlan: 'Настроить план',
  billingCycle: 'Цикл выставления счетов',
  needHelpToGetStarted: 'Нужна помощь, чтобы начать?',
  browser: 'Браузер: {{name}}',
  deviceOs: 'Устройство: {{name}}',
  lastActive: 'Последний активный: {{timestamp}}',
  signUp: 'Зарегистрироваться',
  useGalarmOnWeb: 'Использование Galarm в Интернете',
  welcomeUser: 'Добро пожаловать {{name}}',
  changePassword: 'Изменить пароль',
  saveAlarm: 'Сохранить сигнал тревоги',
  galarmUserTip: 'Знаете ли вы?',
  sendAlarm: 'Отправить сигнал тревоги',
  saveGroup: 'Сохранить группу',
  webAppBestViewedOnDesktop:
    'URL-адрес (web.galarm.app) предназначен для запуска интерфейса Galarm в веб-браузере на вашем ноутбуке или настольном компьютере.\n\nДля использования Galarm на мобильном устройстве установите приложение для Android из Google Play или приложение для iOS из App Store по одной из ссылок ниже:',
  scanQrCodeMessage: 'Сканирование QR-кода',
  reloadQrCode: 'Нажмите, чтобы перезагрузить QR-код',
  invalidQrCodeScanned: 'Отсканирован недействительный QR-код.',
  unableToScanCode: 'Невозможно отсканировать код',
  unableToScanCodeMessage:
    'Возникла проблема при сканировании кода. Пожалуйста, попробуйте еще раз. Если у вас по-прежнему возникают проблемы, пожалуйста, отправьте нам отзыв из мобильного приложения, используя "Настройки > Обратная связь".',
  problemWithEnterpriseAccountSetup:
    'Возникла проблема с настройкой вашей учетной записи Galarm Pro. Обратитесь в службу технической поддержки.',
  problemWithCreatingCheckoutSession:
    'Возникла проблема при создании сеанса проверки. Обратитесь в службу технической поддержки.',
  problemWithCreatingCustomerPortalSession:
    'Возникла проблема при создании сеанса портала клиента. Обратитесь в службу технической поддержки.',
  problemWithCreatingApiKey:
    'Возникла проблема с созданием ключа API. Пожалуйста, обратитесь в службу технической поддержки.',
  creatingAnAccount: 'Создание учетной записи',
  currentPlan: 'Текущий план: {{name}} ({{quantity}} мест)',
  myAccount: 'Информация о счете',
  new: 'Новый',
  deleteAllAlarmHistoryAlertTitle: 'Удаление истории тревог',
  deleteAllAlarmHistoryAlertMessage:
    'Нажмите "Продолжить", чтобы удалить историю для этого сигнала. Это действие нельзя отменить.',
  ageOutInactiveAlarmsMessage:
    'У вас есть {{count}} будильников, которые были неактивны более 60 дней. Большое количество неактивных будильников может повлиять на производительность приложения.\n\nХотите ли вы удалить эти сигналы?',
  duplicateAlarm: 'Дублирующая сигнализация',
  graduallyIncreaseVolume: 'Постепенно увеличивайте объем',
  graduallyIncreaseVolumeTooltipMessage:
    'При включении этого параметра громкость будильника постепенно увеличивается до настроенной громкости мелодии звонка. Это позволяет остановить сигнал до того, как он станет слишком громким.\n\nЕсли этот параметр отключен, сигналы тревоги будут звучать с настроенной громкостью звонка в течение всего времени звучания.',
  teams: 'Команды',
  alerts: 'Оповещения',
  listeners: 'Слушатели',
  noMembersConfiguredInEnterpriseAccount:
    'Вы еще не добавили ни одного участника. Участники - это пользователи, которые могут быть добавлены в политику эскалации слушателя и получать оповещения об инцидентах, полученных слушателем. Эти люди уже должны быть зарегистрированы в Galarm.',
  noTeamsConfiguredInEnterpriseAccount:
    'Вы еще не создали ни одной команды. Команды - это группы участников, которые могут быть добавлены в политику эскалации слушателя и получать оповещения об инцидентах, полученных слушателем.',
  noAlertsConfiguredInEnterpriseAccount:
    'Вы еще не создали ни одного слушателя. Вы можете настроить слушателей для прослушивания инцидентов, о которых сообщают инструменты мониторинга. Создав слушателя, вы можете просмотреть инструкции по интеграции слушателя с различными инструментами мониторинга.\n\nВы можете настроить несколько уровней эскалации для каждого слушателя.',
  noShiftsConfiguredInEnterpriseAccount:
    'Вы еще не создали никаких конфигураций смены.',
  noRotationsConfiguredInEnterpriseAccount:
    'Вы еще не создали никаких вращений.',
  rotations: 'Вращения',
  addRotation: 'Добавить вращение',
  enterRotationName: 'Введите название вращения',
  rotationType: 'Тип вращения',
  numberOfHoursInRotation: 'Количество часов в ротации',
  numberOfDaysInRotation: 'Количество дней в ротации',
  numberOfWeeksInRotation: 'Количество недель в ротации',
  specify: 'Укажите...',
  noIntegrationsConfiguredInEnterpriseAccount:
    'Вы еще не настроили никаких интеграционных конфигураций.',
  loadingUser: 'Загрузка информации о пользователе',
  addMember: 'Добавить участника',
  add: 'Добавить',
  noUserFoundWithMobileNumber:
    'Не найдено ни одного зарегистрированного пользователя Galarm с этим номером телефона. Пожалуйста, убедитесь, что вы ввели номер телефона с кодом страны без специальных символов, таких как скобки, тире, пробелы и т.д.',
  memberWithPhoneNumberAlreadyAdded:
    'Участник с таким номером телефона уже добавлен.',
  memberWithEmailAlreadyAdded:
    'Участник с таким электронным адресом уже добавлен.',
  assignKeyToMember: 'Назначение лицензионного ключа',
  revokeKeyFromMember: 'Отозвать лицензионный ключ',
  cantAssignKeyToMember: 'Невозможно назначить ключ участнику',
  noEnterpriseLicenseKeyAvailable:
    'Лицензионные ключи недоступны. Пожалуйста, обновите свой тарифный план.',
  addTeam: 'Добавить команду',
  enterTeamName: 'Введите название команды',
  addAlert: 'Добавить слушателя',
  low: 'Низкий',
  medium: 'Средний',
  high: 'Высокий',
  severity: 'Тяжесть',
  enterAlertName: 'Введите имя для слушателя',
  organization: 'Организация',
  startTime: 'Время начала',
  endTime: 'Конец времени',
  shiftName: 'Смена {{index}}',
  addShift: 'Добавить смену',
  assignees: 'Получатели',
  shiftStartEndTime: '{{startTime}} - {{endTime}}',
  assignee: 'Назначение',
  specifyAssigneeForShift: 'Укажите ответственного за смену',
  selectAtLeastOneMember: 'Выберите хотя бы одного участника',
  editMember: 'Член редакции',
  editTeam: 'Команда редакторов',
  cantRemoveMemberAssignedToTeamsOrAlerts:
    'Участник состоит в команде или назначен слушателем. Пожалуйста, удалите пользователя из этих команд/слушателей перед удалением.\nКоманды: {{teams}}\nСлушатели: {{alerts}}',
  cantRevokeKeyFromMemberAssignedToTeamsOrAlerts:
    'Участник входит в состав команды или назначен слушателем. Пожалуйста, удалите участника из этих команд/слушателей, прежде чем отзывать ключ.\nКоманды: {{teams}}\nСлушатели: {{alerts}}',
  cantDeleteTeamAssignedToAlerts:
    'Команда является частью слушателя. Пожалуйста, удалите команду из слушателя перед удалением.\nСлушатели: {{alerts}}',
  cantDeleteRotationAssignedToAlerts:
    'Ротация является частью слушателя. Пожалуйста, удалите команду из слушателя перед удалением.\nСлушатели: {{alerts}}',
  editAlert: 'Редактирование слушателя',
  timezoneDisplayString: '(GMT{{offset}}) {{timezone}}',
  apiKey: 'Ключ API',
  viewApiKey: 'Просмотр ключа API',
  apiKeyWarningMessage:
    'Всегда храните свой ключ API в безопасности. Не сообщайте его никому. Если вы считаете, что ваш ключ API был скомпрометирован, нажмите на кнопку "Изменить" выше, чтобы изменить его. После смены ключа вам нужно будет указать новый ключ во всех местах, где вы запускаете инциденты с помощью REST API',
  integrationConfigs: 'Конфиги интеграции',
  addIntegrationConfig: 'Добавить конфигурацию интеграции',
  editIntegrationConfig: 'Редактирование конфигурации интеграции',
  integrationSource: 'Источник интеграции',
  apiToken: 'Токен API',
  integrations: 'Интеграции',
  selectPlaceholder: 'Выберите...',
  zendeskSubdomain: 'Поддомен Zendesk',
  creatorTimeForBuddyAlarm: '{{timeString}} ({{remindMeAfter}})',
  nextFiveAlarms: 'Следующие 5 тревог',
  categories: 'Категории',
  viewingAlarmsDueToday:
    'Просмотр сигналов тревоги должен быть выполнен сегодня',
  viewingAlarmsDueTomorrow:
    'Просмотр сигналов тревоги должен состояться завтра',
  expiredAlarms: 'Сигналы тревоги с истекшим сроком годности',
  viewingExpiredAlarms: 'Просмотр сигналов тревоги с истекшим сроком действия',
  noAlarmsDueToday: 'Никаких тревог сегодня не будет',
  noAlarmsDueTomorrow: 'Завтра никаких тревог.',
  noExpiredAlarms: 'Нет просроченных сигналов тревоги',
  viewingAllAlarms: 'Просмотр всех сигналов тревоги',
  viewingRecentlyDeletedAlarms: 'Просмотр недавно удаленных сигналов тревоги',
  summaryView: 'Попробовать режим просмотра сводок?',
  summaryViewDescription:
    'Просматривайте оповещения, упорядоченные по срокам и категориям.\n\nВернуться к просмотру списка можно с помощью кнопки ⋮ в правом верхнем углу.',
  disableBatteryOptimizationMessageOnStartup:
    'Для надежного срабатывания сигнализации Galarm должен работать в фоновом режиме. Пожалуйста, разрешите это на следующем экране.',
  disableBatteryOptimizationMessage:
    'Для надежного срабатывания сигнализации Galarm должен работать в фоновом режиме.',
  allowNotificationsToDisplayAlarms:
    'Galarm необходимо разрешение на показ уведомлений о звонках будильника.',
  scheduleExactAlarmsMessage:
    'Galarm требуется разрешение на точное планирование сигналов тревоги.',
  alarmCategoryWithSameNameExists:
    'Категория с таким названием уже существует. Пожалуйста, укажите другое имя.',
  alarmRepetitionsPremiumFeature: 'Расширенные параметры повторения',
  ringtonesPremiumFeature: 'Другие рингтоны',
  galarmWebPremiumFeature: 'Использование Galarm в Интернете',
  taskListPremiumFeature: 'Создание нескольких списков задач',
  preReminderPremiumFeature: 'Предварительное напоминание о сигналах тревоги',
  alarmCategoriesPremiumFeature: 'Пользовательские категории сигнализации',
  shareableAlarmLinksPremiumFeature: 'Общие ссылки на сигнализацию',
  announceAlarmNamePremiumFeature: 'Объявить название сигнала тревоги',
  manageSubscription: 'Управление подпиской',
  purchaseRestored: 'Покупайте восстановленные.',
  unableToRetrieveSubscriptionPlansAndroid:
    'Мы не можем подключиться к Google Play, чтобы выполнить обновление. Пожалуйста, убедитесь, что вы подключены к Интернету, а затем повторите попытку. \n\nПожалуйста, сообщите о проблеме в нашу службу поддержки, если она не исчезнет.',
  unableToRetrieveSubscriptionPlansIos:
    'Мы не можем подключиться к App Store, чтобы выполнить обновление. Пожалуйста, убедитесь, что вы подключены к Интернету, а затем повторите попытку. \n\nПожалуйста, сообщите о проблеме в нашу службу поддержки, если она не исчезнет.',
  drawOverOtherApps: 'Отображение поверх других приложений',
  drawOverOtherAppsHelperText:
    'Разрешите Galarm показывать предупреждения о тревоге сверху',
  learnHowToUseFocus: 'Обучение фокусу',
  enhancedNotificationsDeprecated: 'Расширенные уведомления устарели',
  enhancedNotificationsDeprecatedMessage:
    'Мы обнаружили, что расширенные уведомления ненадежны и вызывают чрезмерный разряд батареи. Пожалуйста, используйте iOS Focus, чтобы позволить Galarm вызывать будильники, когда ваш телефон находится в режиме "Не беспокоить".',
  usingIosFocus: 'Использование фокуса iOS',
  iosFocusModePara1:
    'Galarm не будет звонить, если переключатель звонка телефона выключен или если громкость звонка равна 0.\n\nApple рекомендует использовать функцию "Фокус", если вы хотите, чтобы телефон работал без звука, но при этом некоторые приложения могли уведомлять вас. Чтобы настроить "Фокус" на своем телефоне, воспользуйтесь следующими инструкциями.',
  iosFocusModePara2:
    'Более подробные инструкции со скриншотами можно посмотреть на сайте https://galarm.zendesk.com/hc/en-us/articles/10906890793236-Allow-alarms-to-ring-on-silent-on-iOS.',
  settingFocus: 'Настройка фокуса:',
  settingFocusFootNotes:
    'Обратите внимание, что Focus доступен на iOS 15 и выше.\n\nДля получения вопросов или отзывов свяжитесь с нами через "Настройки > Обратная связь".',
  enablingFocus: 'Фокус на развитии:',
  settingFocusInstruction1: 'Перейдите в раздел "Настройки телефона > Фокус".',
  settingFocusInstruction2: 'Нажмите на профиль фокуса "Не беспокоить".',
  settingFocusInstruction3: 'Нажмите на "Приложения" и добавьте Galarm.',
  settingFocusInstruction4:
    'Сделайте то же самое с другими профилями Focus, которые вы установили.',
  enablingFocusInstruction1:
    'Проведите пальцем вниз от правого верхнего края, чтобы открыть Центр управления.',
  enablingFocusInstruction2: 'Нажмите на кнопку Фокус.',
  enablingFocusInstruction3:
    'Нажмите на "Не беспокоить" или любой другой профиль Focus, который вы хотите включить.',
  enablingFocusInstruction4:
    'Включенный фокус отображается как выбранный. Вы можете снова нажать на него, чтобы отключить.',
  startDateForRotation: 'Дата начала ротации',
  startTimeForRotation: 'Время начала вращения',
  member: 'Член',
  multipleShiftsInADay: 'Несколько смен в течение дня',
  escalationPolicy: 'Политика эскалации',
  atTimeOfEvent: 'На момент события',
  afterNMinutes: 'Через {{count}} минут',
  afterNHours: { one: 'Через 1 час', other: 'После {{count}} часов' },
  afterDuration: 'После {{durationString}}',
  addTrigger: 'Добавить триггер',
  viewCode: 'Посмотреть код',
  apiCodes: 'Коды API',
  viewIncidents: 'Просмотреть происшествия',
  incidentsForAlert: 'Инциденты для слушателя {{alertName}}',
  timestamp: 'Временная метка',
  acknowledged: 'Подтверждено',
  noIncidentsForAlert: 'Для этого слушателя пока нет происшествий',
  apiCodeCopiedToClipboard: 'Код API был скопирован в буфер обмена.',
  triggerName: 'Триггер {{index}}',
  delay: 'Задержка',
  chooseAssigneePlaceholder: 'Выберите Назначение...',
  delayForTrigger: 'Задержка срабатывания',
  assigneeWillBeAlertedAfterDelay:
    'Получатель будет оповещен после {{durationString}}.',
  escalationForIncidentsForAlert:
    'Эскалация инцидента на сайте {{incidentDate}} для слушателя {{alertName}}',
  alertIncidentAcknowledged: 'Принято по адресу {{memberName}}. {{dateString}}',
  alertIncidents: 'Инциденты',
  viewingAlertIncidents: 'Просмотр инцидентов',
  createOrganization: 'Создать организацию',
  youAreNotPartOfAnyOrganization:
    'Вы не состоите ни в одной организации. Создайте организацию, чтобы начать работу.',
  tellUsAboutYourOrganization: 'Расскажите нам о своей организации',
  noActiveSubscription: 'У вас нет активной подписки.',
  chooseOrganization: 'Выберите организацию, чтобы продолжить.',
  noTriggersForIncident: 'Для этого инцидента не найдено триггеров.',
  role: 'Роль',
  viewer: 'Просмотрщик',
  newOrganization: 'Новая организация',
  noOrganizations: 'Вы не являетесь частью какой-либо организации.',
  maxOrganizationsReached:
    'Пользователь может состоять не более чем в 10 организациях.',
  yourOrganizations: 'Организации',
  urlNotFound: 'URL не соответствует ни одному поддерживаемому маршруту.',
  triggerAlert: 'Триггерный инцидент',
  recaptchaFailed: 'Проверка reCAPTCHA не удалась. {{error}}',
  loadingAccountInformation: 'Загрузка информации о счете',
  loadingAuthInfo: 'Загрузка информации об аутентификации',
  allAlerts: 'Все слушатели',
  recentlyTriggeredAlerts: 'Недавно сработавшие слушатели',
  recentlyClosedIncidents: 'Недавно закрытые инциденты',
  noRecentlyTriggeredAlerts: 'В последнее время слушатели не срабатывали.',
  noRecentlyClosedIncidents:
    'За последнее время не было закрыто ни одного инцидента.',
  closedAt: 'Закрыто в {{dateTimeString}}',
  dashboard: 'Приборная панель',
  viewIncidentEscalation: 'Просмотр Эскалация инцидентов',
  closeIncident: 'Близкий инцидент',
  closingIncident: 'Инцидент с закрытием',
  unableToRefreshEnterpriseAccount: 'Невозможно обновить учетную запись.',
  viewAuthToken: 'Просмотр аутентификационного токена',
  problemWithCreatingAuthToken:
    'Возникла проблема с созданием маркера доступа. Обратитесь в службу технической поддержки.',
  authToken: 'Токен авторизации',
  authTokenWarningMessage:
    'Постоянно храните этот токен авторизации в безопасности. Не передавайте его никому. Если вы считаете, что ваш API-ключ был скомпрометирован, нажмите на кнопку "Изменить" выше, чтобы изменить его. После смены токена вам нужно будет указать новый токен во всех местах, где вы инициируете инциденты с помощью REST API',
  authTokenCopiedToClipboard:
    'Аутентификационный токен был скопирован в буфер обмена.',
  resendVerificationEmail: 'Повторная отправка проверочного письма',
  loggedInUsingEmail:
    'Войдите в систему, используя электронную почту {{email}}.',
  checkingIfMemberIsAppUser: 'Проверяет, является ли пользователь приложением.',
  settingMemberDetails: 'Установка сведений об участнике.',
  addingTeam: 'Добавление команды.',
  editingTeam: 'Команда редакторов.',
  addingRotation: 'Добавление вращения.',
  editingRotation: 'Редактирование вращения.',
  assigningKeyToMember: 'Назначение ключа участнику.',
  revokingKeyFromMember: 'Отзыв ключа у участника.',
  deletingTeam: 'Удаление команды.',
  deletingRotation: 'Удаление вращения.',
  addingAlert: 'Добавление слушателя.',
  editingAlert: 'Редактирование слушателя.',
  deletingAlert: 'Удаление слушателя.',
  triggeringAlert: 'Инцидент, послуживший поводом.',
  creatingOrganizationAccount: 'Создание учетной записи организации.',
  creatingCheckoutSession: 'Запуск сеанса проверки.',
  creatingAnAccountForMember: 'Создание учетной записи для пользователя.',
  passwordResetEmailSent:
    'Мы отправили вам письмо для сброса пароля. Измените пароль и войдите в систему снова.',
  changeOwner: 'Сменить владельца',
  changeOrganizationOwner: 'Изменить владельца организации',
  newOwnerEmail: 'Электронная почта нового владельца',
  saveOnYearlySubscription: 'Сохранить {{percent}}%',
  annual: 'Ежегодно',
  resetAlarms: 'Обновить сигналы тревоги',
  resetAlarmsAlert:
    'Все сигналы тревоги были обновлены. Если вы продолжаете наблюдать проблемы с оповещениями, пожалуйста, отправьте тикет, используя опцию "Сообщить о проблеме".',
  resetAlarmsTooltipMessage:
    'Если у вас возникли проблемы с сигналами тревоги, например, удаленные сигналы звонят на телефон, обновите сигналы тревоги с помощью этой опции. Если проблема сохраняется, отправьте тикет, используя опцию "Сообщить о проблеме".',
  resetTempPassword: 'Сброс временного пароля',
  currPassword: 'Текущий пароль',
  tempPassword: 'Временный пароль',
  newPassword: 'Новый пароль',
  reset: 'Сброс',
  loggingIn: 'Вход в систему',
  resettingTempPassword: 'Сброс временного пароля',
  changingPassword: 'Изменение пароля',
  numSeats: 'Количество мест',
  helpMeDecide: 'Помогите мне принять решение',
  numEnterpriseSeatsHelper:
    'Количество мест должно соответствовать количеству людей в вашей организации, которые будут использовать приложение для получения инцидентов. При настройке слушателя можно указать его политику эскалации. В политике эскалации может быть несколько уровней. Например, вы можете указать, что первый уровень эскалации - это команда из 3 человек. Если первый уровень эскалации не отвечает в течение 5 минут, второй уровень эскалации переходит к команде из 5 человек. Количество мест в этом случае можно указать равным 8.',
  numBusinessSeatsHelper:
    'Выберите количество мест, соответствующее числу людей, которые будут использовать Galarm для получения сигналов и напоминаний.',
  perSeatPrice: '{{price}} за {{interval}} за место',
  doneForToday: 'Подтверждено',
  getStarted: 'Начать',
  firstAlertInstructions: 'Инструкции для первого слушателя',
  learnMoreAboutGalarmEnterprise: 'Узнайте больше о Galarm Pro',
  home: 'Главная',
  team: 'Команда',
  alert: 'Оповещение',
  listener: 'Слушатель',
  forgotPassword: 'Забыли пароль?',
  forgotPasswordTitle: 'Забыли пароль',
  sendPasswordResetEmail: 'Отправить письмо для сброса пароля',
  sendingPasswordResetEmail:
    'Отправка сообщения электронной почты для сброса пароля',
  field: 'Поле',
  description: 'Описание',
  requestIntegration: 'Запросите другую интеграцию',
  integrationDetails: 'Детали интеграции',
  enterIntegrationDetails: 'Предоставьте детали интеграции',
  galarmEnterpriseFreeTrial:
    'Зарегистрируйтесь на 14-дневную бесплатную пробную версию',
  galarmEnterpriseFreeTrialDescription: 'Автоматизация управления инцидентами',
  bySigningUpYouAgreeToOur: 'Подписываясь, вы соглашаетесь с нашим',
  and: 'и',
  alarmSubscribers: 'Последователи сигнализации',
  otherSubscribersCount: {
    one: 'Еще 1 последователь, которого нет в ваших контактах',
    other: '{{count}} больше последователей, которых нет в ваших контактах'
  },
  getAccountData: 'Экспорт данных тревоги',
  getAccountDataPrompt:
    'Укажите адрес электронной почты, на который мы отправим текстовый файл со всеми вашими сигналами тревоги.',
  getAccountDataConfirmation:
    'Обратите внимание, что мы отправим вам по электронной почте текстовый файл со всеми вашими сигналами тревоги на адрес {{email}}.',
  sendingAccountData: 'Экспорт данных тревоги...',
  sentAccountData: 'Данные о тревоге отправляются на {{email}}.',
  errorSendingAccountData: 'Ошибка экспорта данных тревоги: {{error}}',
  sendingEmailVerificationLink:
    'Отправка ссылки для проверки электронной почты',
  viewLogs: 'Просмотр журналов',
  message: 'Сообщение',
  billing: 'Выставление счетов',
  newIncidentForAlert: 'Новый инцидент для слушателя {{alertName}}',
  clickNextAfterAddingMembers: 'Нажмите "Далее" после добавления участников',
  clickDoneAfterAddingAlerts:
    'Нажмите "Готово", чтобы завершить настройку и перейти к панели управления.',
  alertCreatedSuccessfully:
    'Слушатель успешно создан. Вы можете вызвать этот слушатель с помощью значка меню с тремя точками перед именем слушателя.',
  fixSubscription: 'Исправить подписку',
  fixSubscriptionDescription:
    'Мы обнаружили проблему с вашей подпиской. Ваша подписка содержит место(а) {{numSeats}}, но вы назначили ключи участнику(ам) {{numSeatsAssigned}}. Вы можете назначить не более {{numSeats}} ключей.',
  fixSubscriptionChooseOption:
    'Пожалуйста, исправьте подписку, воспользовавшись одним из предложенных ниже вариантов.',
  fixSubscriptionContactAdmin: 'Обратитесь к администратору вашей организации.',
  unassignKeysFromMembers:
    'Отмените назначение, по крайней мере, {{extraKeysAssigned}} ключа(ей) от членов.',
  addMoreSeatsToSubscription:
    'Добавьте к подписке не менее {{extraKeysAssigned}} мест.',
  revokeMembersKey: 'Отозвать ключ участника',
  revokeMembersKeyDescription:
    'Выберите участников, чьи ключи вы хотите отозвать.',
  revoke: 'Отменить',
  unableToRevokeMembersKey:
    'Произошла ошибка при отзыве ключа пользователя. Пожалуйста, свяжитесь со службой поддержки.',
  problemWithLoadingProducts: 'Проблема с загрузкой продуктов. {{error}}',
  verificationCompleted: 'Проверка завершена',
  deviceAlreadyRegistered:
    'Этот номер телефона уже был ранее проверен на этом устройстве.',
  phoneNumberAutoFilled:
    'Galarm будет использовать выбранный номер телефона из вашего аккаунта Google.',
  unableToRegisterPreVerifiedUser:
    'Невозможно зарегистрировать предварительно проверенного пользователя.',
  allowNotifications: 'Разрешить уведомления',
  allowNotificationsDescription:
    'Чтобы отобразить сигналы тревоги, когда они звонят.',
  scheduleExactAlarms: 'Сигналы тревоги по расписанию',
  scheduleExactAlarmsHelperText:
    'Позволяет Galarm вызывать будильники в точное время.',
  scheduleExactAlarmsDescription: 'Звонок будильника в точное время.',
  disableBatteryOptimization: 'Управление оптимизацией работы аккумулятора',
  disableBatteryOptimizationDescription:
    'Чтобы разрешить Galarm работать в фоновом режиме.',
  requestRequiredPermissions:
    'Galarm требует следующих разрешений для вызова тревоги',
  allowDisallowedPermissions: 'Нажмите, чтобы разрешить',
  notificationsAreEnabled: 'Разрешение на показ уведомлений уже получено.',
  connectingToStore: 'Подключение к магазину...',
  restartApp: 'Перезапустить приложение',
  updateAvailable: 'Доступно обновление',
  english: 'Английский язык',
  russian: 'Русский',
  german: 'Немецкий язык',
  french: 'Французский',
  spanish: 'Испанский',
  italian: 'Итальянский',
  portuguese: 'Португальский',
  japanese: 'Японский',
  korean: 'Корейский',
  indonesian: 'Индонезия',
  changeAppLanguage: 'Изменить язык приложения',
  appLanguage: 'Язык приложений',
  iosChangeAppLanguagePara1:
    'Galarm выбирает язык приложения из настроек вашего телефона. Чтобы изменить язык приложения Galarm, выполните следующие действия:',
  iosChangeAppLanguageInstruction1:
    'Откройте "Настройки телефона > Общие > Язык и регион". Убедитесь, что язык, который вы хотите использовать для Galarm, присутствует в списке предпочтительных языков.',
  iosChangeAppLanguageInstruction2:
    'Вернитесь в "Настройки телефона" и нажмите на "Galarm" в списке приложений внизу.',
  iosChangeAppLanguageInstruction3:
    'Нажмите на "Язык" и выберите язык, который вы хотите установить для Galarm. Вернитесь в приложение после выбора языка',
  androidChangeAppLanguagePara1:
    'Galarm выбирает язык приложения из настроек вашего телефона. Чтобы изменить язык приложения Galarm, выполните следующие действия:',
  androidChangeAppLanguageInstruction1:
    'Нажмите на кнопку "Открыть настройки приложения" внизу.',
  androidChangeAppLanguageInstruction2:
    'Нажмите на "Язык" и выберите язык, который вы хотите использовать для Galarm.',
  androidChangeAppLanguageInstruction3:
    'Выбрав язык, вернитесь сюда и нажмите кнопку "Перезапустить приложение".',
  problemRetrievingSubscriptionData:
    'Возникла проблема с получением информации о вашей подписке. Мы перенаправляем вас на страницу учетной записи. Пожалуйста, проверьте статус вашей подписки и свяжитесь с технической поддержкой, если у вас продолжаются проблемы.',
  deletingOrganization: 'Удаление организации...',
  deleteOrganization: 'Удалить организацию',
  deleteOrganizationDescription:
    'Вы уверены, что хотите удалить свою организацию?\n  \n  Это необратимая операция. Все данные вашей организации будут удалены.\n  \n  Пожалуйста, убедитесь, что вы отменили подписку, прежде чем удалять организацию.',
  galarmEnterpriseTrialDescription:
    'Существует 14-дневная бесплатная пробная версия, в течение которой вы можете отказаться от сублимации без какой-либо платы.',
  galarmEnterpriseTrialAlreadyAvailed:
    'Вы уже воспользовались 14-дневной бесплатной пробной версией. Свяжитесь со службой поддержки, если вам нужно больше времени, чтобы оценить продукт.',
  signinWithGoogle: 'Войдите в систему с помощью Google',
  signinWithGithub: 'Войдите в систему с помощью GitHub',
  verifyAccount: 'Подтвердить учетную запись',
  verifyAccountMessage:
    'Вы должны были получить электронное письмо с проверочным кодом. Введите код ниже, чтобы подтвердить свою учетную запись. Если вы не получили код, вы можете запросить новый код, нажав на кнопку "Повторно отправить код".',
  verificationCode: 'Код проверки',
  optionalString: '{{string}}',
  quickReminderTitle: 'Название (необязательно)',
  accountVerified: 'Аккаунт подтвержден',
  accountVerifiedMessage:
    'Пожалуйста, войдите в систему, используя свои учетные данные.',
  multipleUsersWithSameEmail:
    'Есть несколько пользователей с одинаковой электронной почтой. Пожалуйста, обратитесь в службу поддержки.',
  multipleUsersWithSameMobileNumber:
    'Есть несколько пользователей с одним и тем же номером мобильного телефона. Пожалуйста, обратитесь в службу поддержки.',
  startTrial: 'Начать испытание',
  nextSteps: 'Следующие шаги',
  firstTimeSetupComplete:
    'Вы завершили начальную настройку Galarm Enterprise и создали своего первого слушателя. Ниже перечислены дальнейшие шаги, которые вы можете предпринять.',
  testTheAlertInstruction:
    'Ознакомьтесь с инструкциями на сайте {{link}}, чтобы узнать, как протестировать только что созданный слушатель.',
  integrateTheAlertInstruction:
    'Ознакомьтесь с инструкциями на сайте {{link}} по интеграции слушателя с различными инструментами мониторинга.',
  createMoreAlertsInstruction:
    'Вы можете добавить больше слушателей, перейдя на вкладку "Слушатели" слева.',
  addMoreMembersInstruction:
    'Вы можете добавить новых участников, перейдя на вкладку "Участники" слева.',
  createTeamsInstruction:
    'Вы можете объединять участников в "Команды" и оповещать всю команду при возникновении инцидента. Создайте команды, перейдя на вкладку "Команды" слева, и используйте их в конфигурации слушателя.',
  testTheAlert: 'Протестируйте слушателя',
  integrateTheAlert: 'Интеграция слушателя',
  createMoreAlerts: 'Создайте больше слушателей',
  addMoreMembers: 'Добавить новых участников',
  createTeams: 'Создавайте команды',
  contactSupport: 'Контактная поддержка',
  pastDue: 'Просроченная задолженность',
  canceled: 'Отменено',
  unpaid: 'Неоплаченный',
  incomplete: 'Неполный',
  incomplete_expired: 'Незавершенный Просроченный',
  trialing: 'Бесплатная пробная версия',
  paused: 'Пауза',
  plan: 'План',
  status: 'Статус',
  renewsOn: 'Обновляется',
  yourRoles: 'Ваши роли',
  enterprisePlan: '{{quantity}} места, обновляется каждый {{interval}}',
  currentOrganization: 'Действующая организация',
  useThisOrganization: 'Используйте эту организацию',
  fixPayment: 'Исправить оплату',
  fixingPayment: 'Фиксирование оплаты',
  addPaymentInformation: 'Добавить информацию о платеже',
  noPaymentInformationAvailable:
    'Информация об оплате отсутствует. Пожалуйста, обновите страницу, если вы недавно добавили информацию о платеже.',
  openBillingPortal: 'Открытый биллинговый портал',
  startupWizardDescription:
    'Этот мастер поможет вам начать работу и создать своего первого слушателя.',
  userNotFound: 'Пользователь не найден',
  wrongPassword: 'Неверный пароль',
  emailAlreadyInUse: 'Электронная почта уже используется',
  restoreDeletedAlarms: 'Восстановление удаленных сигналов тревоги',
  deleteAlarmAlert:
    'Удаленные будильники можно восстановить из раздела "Недавно удаленные будильники". Их можно просмотреть, нажав на меню с тремя точками (⋮) в правом верхнем углу вкладки "Будильники".\n\nУдаленные сигналы остаются там в течение 30 дней, после чего они удаляются навсегда.',
  slackVerificationCode: 'Ваш код проверки Slack - {{verificationCode}}.',
  dndAccess: 'Не беспокоить',
  dndHelperText:
    'Разрешите Galarm вызывать будильники, когда ваш телефон находится в режиме "Не беспокоить".',
  cantRestoreInstantAlarmMessage:
    'Мгновенные сигналы тревоги не могут быть восстановлены. При необходимости вы можете просмотреть чат и другую информацию по этому сигналу. Этот сигнал будет удален навсегда через 30 дней после удаления.',
  upgradeToUnlockAllFeatures: 'Обновление, чтобы разблокировать все функции',
  otherSignupOptions: 'Другие варианты регистрации:',
  renewSubscription: 'Продлить подписку',
  subscriptionOnHold:
    'В режиме ожидания (Ваш тарифный план предусматривает {{subscriptionQty}} мест.\nно вы выделили {{numSubscriptionKeys}} мест.',
  checklists: 'Задачи',
  checklist: 'Список задач',
  typeToAddTask: 'Тип для добавления задачи',
  specifyTaskName: 'Укажите название задачи',
  otherChecklists: 'Списки задач',
  defaultChecklistName: 'Без названия',
  addTasksToChecklist: 'Добавьте задачи с помощью поля ввода внизу',
  addTasksToDefaultChecklist:
    'Добавляйте задачи с помощью поля ввода внизу... или создайте новый список задач, нажав на кнопку + в правом верхнем углу.',
  createNewChecklist:
    'Вы можете создавать новые списки задач, чтобы отслеживать все связанные задачи в одном месте.',
  addNewChecklist: 'Новый список задач',
  alarmPhoto: 'Тревожная фотография',
  alarmPhotoFeatureTitle: 'Тревожная фотография',
  alarmPhotoFeatureDescriptionPremiumUser:
    'С помощью этой функции вы можете добавить фотографию к будильнику для быстрого визуального оповещения, например, фотографию лекарства, инструкции по выполнению задания, предмета и т. д. Фотография будет отображаться при звонке будильника.',
  alarmPhotoFeatureDescriptionFreeUser:
    'С помощью этой функции вы можете добавить фотографию к будильнику для быстрого визуального оповещения, например, фотографию лекарства, инструкции по выполнению задания, предмета и т. д. Фотография будет отображаться при звонке будильника.\n  \nЭто премиум-функция. Чтобы воспользоваться этой функцией, вам будет предложено перейти на премиум-версию.',
  alarmPhotoPremiumFeature:
    'Добавление фотографии в заметки о сигналах тревоги',
  installPendingAppUpdate:
    'Последнее обновление приложения загружено и готово к установке.',
  numTasks: {
    zero: 'Нет заданий',
    one: '1 задание',
    other: '{{count}} задания'
  },
  numTasksWithCompleted: {
    one: '1 задание, {{completed}} выполнено',
    other: '{{count}} задания, {{completed}} выполнено'
  },
  muteAlarms: 'Отключение звуковых сигналов',
  unmuteAlarms: 'Отключить звуковые сигналы',
  alarmsAreMuted:
    'В настоящее время все ваши будильники отключены. Нажмите, чтобы отключить звук.',
  alarmsHaveBeenMuted:
    'Ваши сигналы тревоги были отключены. Они не будут звонить, пока вы не отключите их.',
  alarmsHaveBeenUnmuted:
    'Ваши сигналы тревоги были отключены. Они должны звонить в соответствии с настройками.',
  deleteChecklist: 'Удалить список задач',
  confirmDeleteChecklist: 'Удалить список задач?',
  confirmDeleteCompletedTasks: 'Удалить выполненные задания?',
  confirmResetCompletedTasks: 'Сбросить завершенные задачи?',
  confirmDeleteTask: 'Удалить {{taskName}}?',
  showCompletedTasks: 'Показать выполненные задания',
  hideCompletedTasks: 'Скрыть завершенные задачи',
  deleteCompletedTasks: 'Удаление завершенных заданий',
  resetCompletedTasks: 'Сброс завершенных заданий',
  yourGroups: 'Ваши группы',
  newAlarmWith: 'Новая сигнализация с {{name}}',
  newGroupWith: 'Новая группа с {{name}}',
  alertContact: 'Оповещение {{name}}',
  alertGroup: 'Оповещение {{name}}',
  instantAlarmMovedToFabNotice:
    'Функция мгновенного оповещения теперь доступна с помощью кнопки "+" в правой нижней части экрана. Значок "громкоговоритель" будет удален из правого верхнего угла в будущем выпуске.',
  tasksIntroTitle: 'Задачи и списки задач',
  tasksIntroDescription:
    'Задачи - это дела, которые не имеют сроков выполнения. Здесь вы можете быстро добавлять их и управлять ими, отмечая их по мере выполнения.\n\nВы также можете создавать списки задач, чтобы группировать похожие задачи. Например, вы можете создать список задач для покупок продуктов, другой - для рабочих задач и так далее.',
  groupsMovedToContactsScreen:
    '"Группы" были объединены в эту вкладку. Ваши группы отображаются вверху в разделе "Ваши группы". Вы можете создавать новые группы, нажимая на кнопку "+" в правом нижнем углу.',
  loadingTasks: 'Загрузка заданий...',
  tryPremium: 'Попробуйте премиум',
  buyPremiumToUnlockFeature:
    'Это функция премиум-класса. Разблокируйте эту и многие другие функции с помощью нашего премиум-плана, который поставляется с 14-дневной бесплатной пробной версией.',
  newTask: 'Новое задание',
  newTaskList: 'Новый список задач',
  enterTaskName: 'Введите название задачи',
  enterTaskListName: 'Введите имя списка задач',
  taskName: 'Название задачи',
  taskListName: 'Имя списка задач',
  checklistTasks: '{{name}}',
  editTaskListName: 'Редактирование названия списка задач',
  editTask: 'Редактирование задания',
  currentRelease: '(в настоящее время установлен)',
  id: 'ID',
  subscriptionData: 'Данные подписки',
  organizations: 'Организации',
  showRotationCalendar: 'Календарь ротации шоу',
  rotationCalendar: 'Календарь ротации',
  editShift: 'Редактировать смену',
  startDateForShift: 'Дата начала смены',
  startTimeForShift: 'Время начала смены',
  endDateForShift: 'Дата окончания смены',
  endTimeForShift: 'Время окончания смены',
  editingShift: 'Редактирование смены',
  addingShift: 'Добавление сдвига',
  products: 'Продукция',
  prices: 'Планы',
  planType: 'Тип плана',
  business: 'Бизнес',
  enterprise: 'Предприятие',
  compare: 'Сравнить',
  apiSupport: 'Поддержка API для мониторинга сервисов',
  accessToConsoleToViewAndCloseIncidents:
    'Приборная панель для управления инцидентами',
  triggerInstantAlertsFromTheConsole:
    'Запуск инцидентов из консоли предприятия',
  coreFeatures: 'Основные характеристики:',
  everythingInBusiness: 'Все в бизнес-плане и:',
  updatePlanInstructions:
    'Вы можете обновить свой план, нажав на кнопку "Открыть биллинговый портал" справа и выбрав кнопку "Обновить план" на биллинговом портале.',
  membersDescription:
    'Вы приобрели {{subscriptionKeysCount}} мест - {{assignedSubscriptionKeysCount}} закрепленное и {{unassignedSubscriptionKeysCount}} свободное. Галочка напротив имени участника означает, что за ним закреплено место.',
  centralBilling: 'Центральный биллинг',
  saveTwoMonths: 'Сохранить 2 месяца',
  owner: 'Владелец',
  enterpriseAccountSummary:
    'Вы являетесь частью организации {{organizationName}}, зарегистрированной в плане Galarm Pro {{planType}}.',
  perYearPerUser: 'на пользователя/год',
  perMonthPerUser: 'за пользователя/месяц',
  creationDate: 'Дата создания',
  updatePhoneNumber: 'Изменить номер телефона',
  confirmCountryCodeAndEnterUpdatedPhoneNumber:
    'Подтвердите код страны и введите свой новый номер телефона. Ваш аккаунт будет привязан к этому номеру телефона после завершения проверки.',
  unableToUpdatePhoneNumber:
    'Невозможно изменить номер телефона: {{error}}. Пожалуйста, свяжитесь со службой поддержки.',
  phoneNumberUpdated: 'Номер телефона успешно изменен.',
  phoneNumberUpdatedMessage:
    'Вы можете начать пользоваться приложением в обычном режиме. Попросите своих контактов обновить ваш номер телефона в их адресной книге.',
  memberChangedPhoneNumber:
    '{{memberName}} сменил номер телефона. Пожалуйста, обновите свою адресную книгу, чтобы продолжить добавлять их в свои оповещения.',
  preferredSourceForIncidents:
    'Предпочтительный источник информации о происшествиях',
  apiCodesDescription:
    'Используйте следующие инструкции для интеграции слушателя с источником',
  rotation: 'Вращение',
  noAlarmsForThisDay: 'Никаких тревог на этот день',
  markAlarmsAsComplete: 'Пометьте сигналы тревоги как завершенные',
  markAlarmsAsCompleteExplanation:
    'Однократные сигналы тревоги будут отмечены как завершенные и появятся в разделе "Неактивные" сигналы тревоги.\n\nПовторяющиеся тревоги будут отмечены как завершенные и перенесены на следующий случай.',
  enterIncidentPrefix: 'Не более 5 символов',
  incidentPrefix: 'Префикс инцидента',
  incidentPrefixAlreadyExists: 'Префикс инцидента уже существует',
  removeTask: 'Удалить задачу?',
  incidentPrefixLengthExceeded: 'Префикс инцидента длиннее 5 символов',
  criticalAlerts: 'Критические оповещения',
  criticalAlertsConfiguration:
    'Будильник будет звонить с громкостью {{criticalAlertsVolume}}%, даже если телефон выключен или включен фокус.',
  criticalAlertsDisabledShort:
    'Будильник не будет звонить, если телефон отключен.',
  criticalAlertsConfigurationGlobal:
    'Будильники будут звонить с громкостью {{criticalAlertsVolume}}%, даже если телефон выключен или включен Focus.',
  criticalAlertsDisabledShortGlobal:
    'Сигналы тревоги не будут звонить, если телефон отключен.',
  criticalAlertsEnabled:
    'Включены критические оповещения. Сигналы тревоги будут звонить, даже если телефон выключен или включен Focus.',
  criticalAlertsDisabled:
    'Критические оповещения отключены. Сигналы тревоги не будут звонить, если телефон отключен.',
  enableCriticalAlerts: 'Включить критические оповещения',
  summer_soft: 'Летняя мягкость',
  beeps: 'Звуковые сигналы',
  bollywood_nights: 'Болливудские ночи',
  gentle_reminder: 'Нежное напоминание',
  himalayan_piper: 'Гималайская пипера',
  holiday_joy: 'Праздничная радость',
  hollywood_adventure: 'Голливудское приключение',
  melody: 'Мелоди',
  morning_rooster: 'Утренний петух',
  morning_sunshine: 'Утреннее солнце',
  sweet_sea: 'Сладкое море',
  old_school_ring: 'Тринг Тринг',
  MyAlarmNotification: '{{alarmName}} - Пришло время.',
  ParticipantCascadingAlarmNotification:
    '{{alarmName}} - Пришло время напомнить {{alarmCreatorName}}.',
  ParticipantSimultaneousAlarmNotification:
    '{{alarmName}}. Пришло время подтвердить свое участие.',
  InstantAlarmNotification:
    '{{alarmName}}. Просим вашего немедленного внимания.',
  MyAlarmNotificationShort: 'Пришло время.',
  ParticipantCascadingAlarmNotificationShort:
    'Пришло время напомнить {{alarmCreatorName}}.',
  ParticipantSimultaneousAlarmNotificationShort:
    'Пришло время подтвердить свое участие.',
  InstantAlarmNotificationShort: 'Просим вашего немедленного внимания.',
  MyRecipientAlarmNotification:
    '{{alarmName}} - Пришло время напомнить {{alarmRecipientName}}.',
  MyRecipientAlarmNotificationShort:
    'Пришло время напомнить {{alarmRecipientName}}.',
  RecipientAlarmNotification:
    '{{alarmName}} (по {{alarmCreatorName}}) - Пришло время.',
  RecipientAlarmNotificationShort:
    'Время пришло - на сайте {{alarmCreatorName}}.'
}
